import React from "react";
import {
	API_ADMIN_GET_ALL_USER,
	API_ADMIN_GET_ALL_USER_SUCCESS,
	API_ADMIN_GET_USER_SUCCESS,
	ADMIN_RESET_FOCUS_USER,
	ADMIN_INIT_NEW_USER,
	API_ADMIN_POST_USER,
	API_ADMIN_POST_USER_SUCCESS,
	API_ADMIN_PATCH_USER_SUCCESS,
	API_ADMIN_POST_USER_FAIL,
	API_ADMIN_PATCH_USER_FAIL,
	API_ADMIN_PATCH_USER,
	API_ADMIN_DELETE_USER,
	API_ADMIN_DELETE_USER_FAIL,
	API_ADMIN_DELETE_USER_SUCCESS,
	API_ADMIN_GET_SAMPLERS_USER,
	API_ADMIN_GET_SAMPLERS_USER_SUCCESS,
	API_ADMIN_GET_SAMPLERS_USER_FAIL,
} from "actions/user";
import {
	API_ADMIN_GET_ALL_ANALYSISLIBRARY,
	API_ADMIN_GET_ALL_ANALYSISLIBRARY_SUCCESS,
	API_ADMIN_GET_ALL_ANALYSISLIBRARY_FAIL,
	API_ADMIN_GET_ANALYSISLIBRARY_SUCCESS,
	API_ADMIN_GET_ANALYSISLIBRARY,
	ADMIN_RESET_FOCUS_ANALYSISLIBRARY,
	ADMIN_INIT_NEW_ANALYSISLIBRARY,
	API_ADMIN_POST_ANALYSISLIBRARY,
	API_ADMIN_POST_ANALYSISLIBRARY_SUCCESS,
	API_ADMIN_PATCH_ANALYSISLIBRARY_SUCCESS,
	API_ADMIN_POST_ANALYSISLIBRARY_FAIL,
	API_ADMIN_PATCH_ANALYSISLIBRARY_FAIL,
	API_ADMIN_PATCH_ANALYSISLIBRARY,
	API_ADMIN_DELETE_ANALYSISLIBRARY,
	API_ADMIN_DELETE_ANALYSISLIBRARY_FAIL,
	API_ADMIN_DELETE_ANALYSISLIBRARY_SUCCESS,
} from "actions/analysisLibrary";

import {
	API_ADMIN_GET_ALL_TUBELIBRARY,
	API_ADMIN_GET_ALL_TUBELIBRARY_SUCCESS,
	API_ADMIN_GET_ALL_TUBELIBRARY_FAIL,
	API_ADMIN_GET_TUBELIBRARY_SUCCESS,
	ADMIN_RESET_FOCUS_TUBELIBRARY,
	ADMIN_INIT_NEW_TUBELIBRARY,
	ADMIN_UPDATE_FOCUS_PHOTO_TUBELIBRARY,
} from "actions/tubeLibrary";

import {
	API_ADMIN_GET_ALL_QUESTIONLIBRARY,
	API_ADMIN_GET_ALL_QUESTIONLIBRARY_SUCCESS,
	API_ADMIN_GET_ALL_QUESTIONLIBRARY_FAIL,
	API_ADMIN_GET_QUESTIONLIBRARY,
	API_ADMIN_GET_QUESTIONLIBRARY_SUCCESS,
	ADMIN_RESET_FOCUS_QUESTIONLIBRARY,
	ADMIN_INIT_NEW_QUESTIONLIBRARY,
	API_ADMIN_POST_QUESTIONLIBRARY,
	API_ADMIN_POST_QUESTIONLIBRARY_SUCCESS,
	API_ADMIN_PATCH_QUESTIONLIBRARY_SUCCESS,
	API_ADMIN_POST_QUESTIONLIBRARY_FAIL,
	API_ADMIN_PATCH_QUESTIONLIBRARY_FAIL,
	API_ADMIN_PATCH_QUESTIONLIBRARY,
	API_ADMIN_DELETE_QUESTIONLIBRARY,
	API_ADMIN_DELETE_QUESTIONLIBRARY_FAIL,
	API_ADMIN_DELETE_QUESTIONLIBRARY_SUCCESS,
} from "actions/questionLibrary";

import {
	API_ADMIN_GET_ALL_MOTIVATIONSLIBRARY_SUCCESS,
	API_ADMIN_GET_ALL_MOTIVATIONSLIBRARY_FAIL,
	API_ADMIN_GET_MOTIVATIONLIBRARY_SUCCESS,
	API_ADMIN_POST_MOTIVATIONLIBRARY,
	API_ADMIN_POST_MOTIVATIONLIBRARY_FAIL,
	API_ADMIN_POST_MOTIVATIONLIBRARY_SUCCESS,
	API_ADMIN_PATCH_MOTIVATIONLIBRARY,
	API_ADMIN_PATCH_MOTIVATIONLIBRARY_FAIL,
	API_ADMIN_PATCH_MOTIVATIONLIBRARY_SUCCESS,
	API_ADMIN_DELETE_MOTIVATIONLIBRARY,
	API_ADMIN_DELETE_MOTIVATIONLIBRARY_FAIL,
	API_ADMIN_DELETE_MOTIVATIONLIBRARY_SUCCESS,
	ADMIN_RESET_FOCUS_MOTIVATIONLIBRARY,
	ADMIN_INIT_NEW_MOTIVATIONLIBRARY,
} from "actions/motivationLibrary";

import {
	API_ADMIN_GET_ALL_SYSTEMATICQUESTIONLIBRARY,
	API_ADMIN_GET_ALL_SYSTEMATICQUESTIONLIBRARY_SUCCESS,
	API_ADMIN_GET_SYSTEMATICQUESTIONLIBRARY,
	API_ADMIN_GET_SYSTEMATICQUESTIONLIBRARY_SUCCESS,
	ADMIN_RESET_FOCUS_SYSTEMATICQUESTIONLIBRARY,
	ADMIN_INIT_NEW_SYSTEMATICQUESTIONLIBRARY,
	API_ADMIN_POST_SYSTEMATICQUESTIONLIBRARY,
	API_ADMIN_POST_SYSTEMATICQUESTIONLIBRARY_SUCCESS,
	API_ADMIN_PATCH_SYSTEMATICQUESTIONLIBRARY_SUCCESS,
	API_ADMIN_POST_SYSTEMATICQUESTIONLIBRARY_FAIL,
	API_ADMIN_PATCH_SYSTEMATICQUESTIONLIBRARY_FAIL,
	API_ADMIN_PATCH_SYSTEMATICQUESTIONLIBRARY,
	API_ADMIN_DELETE_SYSTEMATICQUESTIONLIBRARY,
	API_ADMIN_DELETE_SYSTEMATICQUESTIONLIBRARY_FAIL,
	API_ADMIN_DELETE_SYSTEMATICQUESTIONLIBRARY_SUCCESS,
} from "actions/systematicQuestionLibrary";

import {
	API_ADMIN_GET_ALL_ANSWEROPTIONLIBRARY,
	API_ADMIN_GET_ALL_ANSWEROPTIONLIBRARY_SUCCESS,
	API_ADMIN_GET_ANSWEROPTIONLIBRARY,
	API_ADMIN_GET_ANSWEROPTIONLIBRARY_SUCCESS,
	ADMIN_RESET_FOCUS_ANSWEROPTIONLIBRARY,
	ADMIN_INIT_NEW_ANSWEROPTIONLIBRARY,
	API_ADMIN_POST_ANSWEROPTIONLIBRARY,
	API_ADMIN_POST_ANSWEROPTIONLIBRARY_SUCCESS,
	API_ADMIN_PATCH_ANSWEROPTIONLIBRARY_SUCCESS,
	API_ADMIN_POST_ANSWEROPTIONLIBRARY_FAIL,
	API_ADMIN_PATCH_ANSWEROPTIONLIBRARY_FAIL,
	API_ADMIN_PATCH_ANSWEROPTIONLIBRARY,
	API_ADMIN_DELETE_ANSWEROPTIONLIBRARY,
	API_ADMIN_DELETE_ANSWEROPTIONLIBRARY_FAIL,
	API_ADMIN_DELETE_ANSWEROPTIONLIBRARY_SUCCESS,
} from "actions/answerOptionLibrary";

import { toast } from "react-toastify";
import { createReducer } from "@reduxjs/toolkit";
import {
	API_ADMIN_GET_ALL_GENERALPARAMETER,
	API_ADMIN_GET_ALL_GENERALPARAMETER_FAIL,
	API_ADMIN_GET_ALL_GENERALPARAMETER_SUCCESS,
	API_ADMIN_PATCH_GENERALPARAMETER,
	API_ADMIN_PATCH_GENERALPARAMETER_FAIL,
	API_ADMIN_PATCH_GENERALPARAMETER_SUCCESS,
} from "actions/generalParameter";
import {
	API_ADMIN_GET_ALL_ANALYSESPACK,
	API_ADMIN_GET_ALL_ANALYSESPACK_SUCCESS,
	API_ADMIN_GET_ANALYSESPACK_SUCCESS,
	ADMIN_RESET_FOCUS_ANALYSESPACK,
	ADMIN_INIT_NEW_ANALYSESPACK,
	API_ADMIN_POST_ANALYSESPACK,
	API_ADMIN_POST_ANALYSESPACK_SUCCESS,
	API_ADMIN_PATCH_ANALYSESPACK_SUCCESS,
	API_ADMIN_POST_ANALYSESPACK_FAIL,
	API_ADMIN_PATCH_ANALYSESPACK_FAIL,
	API_ADMIN_PATCH_ANALYSESPACK,
	API_ADMIN_DELETE_ANALYSESPACK,
	API_ADMIN_DELETE_ANALYSESPACK_FAIL,
	API_ADMIN_DELETE_ANALYSESPACK_SUCCESS,
	API_ADMIN_GET_ANALYSESPACKS_CAMPAIGNS,
	API_ADMIN_GET_ANALYSESPACKS_CAMPAIGNS_SUCCESS,
	API_ADMIN_GET_ANALYSESPACKS_CAMPAIGNS_FAIL,
} from "actions/analysesPack";

import {
	API_ADMIN_GET_ALL_INSURANCE,
	API_ADMIN_GET_ALL_INSURANCE_SUCCESS,
	API_ADMIN_GET_ALL_INSURANCE_FAIL,
	API_ADMIN_GET_INSURANCE,
	API_ADMIN_GET_INSURANCE_SUCCESS,
	API_ADMIN_GET_INSURANCE_FAIL,
	ADMIN_INIT_NEW_INSURANCE,
	ADMIN_RESET_FOCUS_INSURANCE,
	API_ADMIN_POST_INSURANCE,
	API_ADMIN_POST_INSURANCE_FAIL,
	API_ADMIN_POST_INSURANCE_SUCCESS,
	API_ADMIN_PATCH_INSURANCE,
	API_ADMIN_PATCH_INSURANCE_FAIL,
	API_ADMIN_PATCH_INSURANCE_SUCCESS,
	API_ADMIN_DELETE_INSURANCE,
	API_ADMIN_DELETE_INSURANCE_SUCCESS,
	API_ADMIN_DELETE_INSURANCE_FAIL,
} from "actions/insurance";

import {
	API_ADMIN_GET_ALL_DOCUMENT_TYPE,
	API_ADMIN_GET_ALL_DOCUMENT_TYPE_SUCCESS,
	API_ADMIN_GET_ALL_DOCUMENT_TYPE_FAIL,
	API_ADMIN_GET_DOCUMENT_TYPE,
	API_ADMIN_GET_DOCUMENT_TYPE_SUCCESS,
	API_ADMIN_GET_DOCUMENT_TYPE_FAIL,
	ADMIN_INIT_NEW_DOCUMENT_TYPE,
	ADMIN_RESET_FOCUS_DOCUMENT_TYPE,
	API_ADMIN_POST_DOCUMENT_TYPE,
	API_ADMIN_POST_DOCUMENT_TYPE_FAIL,
	API_ADMIN_POST_DOCUMENT_TYPE_SUCCESS,
	API_ADMIN_PATCH_DOCUMENT_TYPE,
	API_ADMIN_PATCH_DOCUMENT_TYPE_FAIL,
	API_ADMIN_PATCH_DOCUMENT_TYPE_SUCCESS,
	API_ADMIN_DELETE_DOCUMENT_TYPE,
	API_ADMIN_DELETE_DOCUMENT_TYPE_SUCCESS,
	API_ADMIN_DELETE_DOCUMENT_TYPE_FAIL,
} from "actions/documentType";

import {
	API_ADMIN_GET_ALL_SPECIAL_REGIME,
	API_ADMIN_GET_ALL_SPECIAL_REGIME_SUCCESS,
	API_ADMIN_GET_ALL_SPECIAL_REGIME_FAIL,
	API_ADMIN_GET_SPECIAL_REGIME,
	API_ADMIN_GET_SPECIAL_REGIME_SUCCESS,
	API_ADMIN_GET_SPECIAL_REGIME_FAIL,
	ADMIN_INIT_NEW_SPECIAL_REGIME,
	ADMIN_RESET_FOCUS_SPECIAL_REGIME,
	API_ADMIN_POST_SPECIAL_REGIME,
	API_ADMIN_POST_SPECIAL_REGIME_FAIL,
	API_ADMIN_POST_SPECIAL_REGIME_SUCCESS,
	API_ADMIN_PATCH_SPECIAL_REGIME,
	API_ADMIN_PATCH_SPECIAL_REGIME_FAIL,
	API_ADMIN_PATCH_SPECIAL_REGIME_SUCCESS,
	API_ADMIN_DELETE_SPECIAL_REGIME,
	API_ADMIN_DELETE_SPECIAL_REGIME_SUCCESS,
	API_ADMIN_DELETE_SPECIAL_REGIME_FAIL,
} from "actions/specialRegime";

import {
	API_ADMIN_GET_ALL_SPECIALTY,
	API_ADMIN_GET_ALL_SPECIALTY_SUCCESS,
	API_ADMIN_GET_ALL_SPECIALTY_FAIL,
	API_ADMIN_GET_SPECIALTY,
	API_ADMIN_GET_SPECIALTY_SUCCESS,
	API_ADMIN_GET_SPECIALTY_FAIL,
	ADMIN_INIT_NEW_SPECIALTY,
	ADMIN_RESET_FOCUS_SPECIALTY,
	API_ADMIN_POST_SPECIALTY,
	API_ADMIN_POST_SPECIALTY_FAIL,
	API_ADMIN_POST_SPECIALTY_SUCCESS,
	API_ADMIN_PATCH_SPECIALTY,
	API_ADMIN_PATCH_SPECIALTY_FAIL,
	API_ADMIN_PATCH_SPECIALTY_SUCCESS,
	API_ADMIN_DELETE_SPECIALTY,
	API_ADMIN_DELETE_SPECIALTY_SUCCESS,
	API_ADMIN_DELETE_SPECIALTY_FAIL,
} from "actions/specialty";

import {
	API_ADMIN_GET_ALL_COMPANY,
	API_ADMIN_GET_ALL_COMPANY_SUCCESS,
	API_ADMIN_GET_ALL_COMPANY_FAIL,
	API_ADMIN_GET_COMPANY,
	API_ADMIN_GET_COMPANY_SUCCESS,
	API_ADMIN_GET_COMPANY_FAIL,
	ADMIN_RESET_FOCUS_COMPANY,
} from "actions/company";

import {
	API_ADMIN_GET_ALL_LAB_PARAM_GROUP,
	API_ADMIN_GET_ALL_LAB_PARAM_GROUP_SUCCESS,
	API_ADMIN_GET_ALL_LAB_PARAM_GROUP_FAIL,
	API_ADMIN_GET_LAB_PARAM_GROUP,
	API_ADMIN_GET_LAB_PARAM_GROUP_SUCCESS,
	API_ADMIN_GET_LAB_PARAM_GROUP_FAIL,
	ADMIN_INIT_NEW_LAB_PARAM_GROUP,
	ADMIN_RESET_FOCUS_LAB_PARAM_GROUP,
	API_ADMIN_POST_LAB_PARAM_GROUP,
	API_ADMIN_POST_LAB_PARAM_GROUP_FAIL,
	API_ADMIN_POST_LAB_PARAM_GROUP_SUCCESS,
	API_ADMIN_PATCH_LAB_PARAM_GROUP,
	API_ADMIN_PATCH_LAB_PARAM_GROUP_FAIL,
	API_ADMIN_PATCH_LAB_PARAM_GROUP_SUCCESS,
	API_ADMIN_DELETE_LAB_PARAM_GROUP,
	API_ADMIN_DELETE_LAB_PARAM_GROUP_SUCCESS,
	API_ADMIN_DELETE_LAB_PARAM_GROUP_FAIL,
} from "actions/labParamGroup";

import {
	API_ADMIN_GET_ALL_LABORATORY,
	API_ADMIN_GET_ALL_LABORATORY_SUCCESS,
	API_ADMIN_GET_ALL_LABORATORY_FAIL,
	API_ADMIN_GET_LABORATORY,
	API_ADMIN_GET_LABORATORY_SUCCESS,
	API_ADMIN_GET_LABORATORY_FAIL,
	ADMIN_INIT_NEW_LABORATORY,
	ADMIN_RESET_FOCUS_LABORATORY,
	API_ADMIN_POST_LABORATORY,
	API_ADMIN_POST_LABORATORY_FAIL,
	API_ADMIN_POST_LABORATORY_SUCCESS,
	API_ADMIN_PATCH_LABORATORY,
	API_ADMIN_PATCH_LABORATORY_FAIL,
	API_ADMIN_PATCH_LABORATORY_SUCCESS,
	API_ADMIN_DELETE_LABORATORY,
	API_ADMIN_DELETE_LABORATORY_SUCCESS,
	API_ADMIN_DELETE_LABORATORY_FAIL,
} from "actions/laboratory";

import {
	API_ADMIN_GET_ALL_EMERGENCY_REASON,
	API_ADMIN_GET_ALL_EMERGENCY_REASON_SUCCESS,
	API_ADMIN_GET_ALL_EMERGENCY_REASON_FAIL,
	API_ADMIN_GET_EMERGENCY_REASON,
	API_ADMIN_GET_EMERGENCY_REASON_SUCCESS,
	API_ADMIN_GET_EMERGENCY_REASON_FAIL,
	ADMIN_INIT_NEW_EMERGENCY_REASON,
	ADMIN_RESET_FOCUS_EMERGENCY_REASON,
	API_ADMIN_POST_EMERGENCY_REASON,
	API_ADMIN_POST_EMERGENCY_REASON_FAIL,
	API_ADMIN_POST_EMERGENCY_REASON_SUCCESS,
	API_ADMIN_PATCH_EMERGENCY_REASON,
	API_ADMIN_PATCH_EMERGENCY_REASON_FAIL,
	API_ADMIN_PATCH_EMERGENCY_REASON_SUCCESS,
	API_ADMIN_DELETE_EMERGENCY_REASON,
	API_ADMIN_DELETE_EMERGENCY_REASON_SUCCESS,
	API_ADMIN_DELETE_EMERGENCY_REASON_FAIL,
} from "actions/emergencyReason";

import {
	API_ADMIN_GET_ALL_VALIDATION_PAUSED_REASON,
	API_ADMIN_GET_ALL_VALIDATION_PAUSED_REASON_SUCCESS,
	API_ADMIN_GET_ALL_VALIDATION_PAUSED_REASON_FAIL,
	API_ADMIN_GET_VALIDATION_PAUSED_REASON,
	API_ADMIN_GET_VALIDATION_PAUSED_REASON_SUCCESS,
	API_ADMIN_GET_VALIDATION_PAUSED_REASON_FAIL,
	ADMIN_INIT_NEW_VALIDATION_PAUSED_REASON,
	ADMIN_RESET_FOCUS_VALIDATION_PAUSED_REASON,
	API_ADMIN_POST_VALIDATION_PAUSED_REASON,
	API_ADMIN_POST_VALIDATION_PAUSED_REASON_FAIL,
	API_ADMIN_POST_VALIDATION_PAUSED_REASON_SUCCESS,
	API_ADMIN_PATCH_VALIDATION_PAUSED_REASON,
	API_ADMIN_PATCH_VALIDATION_PAUSED_REASON_FAIL,
	API_ADMIN_PATCH_VALIDATION_PAUSED_REASON_SUCCESS,
	API_ADMIN_DELETE_VALIDATION_PAUSED_REASON,
	API_ADMIN_DELETE_VALIDATION_PAUSED_REASON_SUCCESS,
	API_ADMIN_DELETE_VALIDATION_PAUSED_REASON_FAIL,
} from "actions/validationPausedReason";

import {
	API_ADMIN_GET_ALL_CONSENT_REFUSAL_REASON,
	API_ADMIN_GET_ALL_CONSENT_REFUSAL_REASON_SUCCESS,
	API_ADMIN_GET_ALL_CONSENT_REFUSAL_REASON_FAIL,
	API_ADMIN_GET_CONSENT_REFUSAL_REASON,
	API_ADMIN_GET_CONSENT_REFUSAL_REASON_SUCCESS,
	API_ADMIN_GET_CONSENT_REFUSAL_REASON_FAIL,
	ADMIN_INIT_NEW_CONSENT_REFUSAL_REASON,
	ADMIN_RESET_FOCUS_CONSENT_REFUSAL_REASON,
	API_ADMIN_POST_CONSENT_REFUSAL_REASON,
	API_ADMIN_POST_CONSENT_REFUSAL_REASON_FAIL,
	API_ADMIN_POST_CONSENT_REFUSAL_REASON_SUCCESS,
	API_ADMIN_PATCH_CONSENT_REFUSAL_REASON,
	API_ADMIN_PATCH_CONSENT_REFUSAL_REASON_FAIL,
	API_ADMIN_PATCH_CONSENT_REFUSAL_REASON_SUCCESS,
	API_ADMIN_DELETE_CONSENT_REFUSAL_REASON,
	API_ADMIN_DELETE_CONSENT_REFUSAL_REASON_SUCCESS,
	API_ADMIN_DELETE_CONSENT_REFUSAL_REASON_FAIL,
} from "actions/consentRefusalReason";

import {
	API_ADMIN_GET_ALL_CONTACT_COMMENT,
	API_ADMIN_GET_ALL_CONTACT_COMMENT_SUCCESS,
	API_ADMIN_GET_ALL_CONTACT_COMMENT_FAIL,
	API_ADMIN_GET_CONTACT_COMMENT,
	API_ADMIN_GET_CONTACT_COMMENT_SUCCESS,
	API_ADMIN_GET_CONTACT_COMMENT_FAIL,
	ADMIN_INIT_NEW_CONTACT_COMMENT,
	ADMIN_RESET_FOCUS_CONTACT_COMMENT,
	API_ADMIN_POST_CONTACT_COMMENT,
	API_ADMIN_POST_CONTACT_COMMENT_FAIL,
	API_ADMIN_POST_CONTACT_COMMENT_SUCCESS,
	API_ADMIN_PATCH_CONTACT_COMMENT,
	API_ADMIN_PATCH_CONTACT_COMMENT_FAIL,
	API_ADMIN_PATCH_CONTACT_COMMENT_SUCCESS,
	API_ADMIN_DELETE_CONTACT_COMMENT,
	API_ADMIN_DELETE_CONTACT_COMMENT_SUCCESS,
	API_ADMIN_DELETE_CONTACT_COMMENT_FAIL,
} from "actions/contactComment";

import {
	API_ADMIN_GET_ALL_TUBE_REASON,
	API_ADMIN_GET_ALL_TUBE_REASON_SUCCESS,
	API_ADMIN_GET_ALL_TUBE_REASON_FAIL,
	API_ADMIN_GET_TUBE_REASON,
	API_ADMIN_GET_TUBE_REASON_SUCCESS,
	API_ADMIN_GET_TUBE_REASON_FAIL,
	ADMIN_INIT_NEW_TUBE_REASON,
	ADMIN_RESET_FOCUS_TUBE_REASON,
	API_ADMIN_POST_TUBE_REASON,
	API_ADMIN_POST_TUBE_REASON_FAIL,
	API_ADMIN_POST_TUBE_REASON_SUCCESS,
	API_ADMIN_PATCH_TUBE_REASON,
	API_ADMIN_PATCH_TUBE_REASON_FAIL,
	API_ADMIN_PATCH_TUBE_REASON_SUCCESS,
	API_ADMIN_DELETE_TUBE_REASON,
	API_ADMIN_DELETE_TUBE_REASON_SUCCESS,
	API_ADMIN_DELETE_TUBE_REASON_FAIL,
	API_ADMIN_GET_TUBE_REASON_GROUPS_SUCCESS,
	API_ADMIN_GET_TUBE_REASON_GROUPS_FAIL,
} from "actions/tubeReason";

import {
	API_ADMIN_GET_ALL_CANCEL_REASON,
	API_ADMIN_GET_ALL_CANCEL_REASON_SUCCESS,
	API_ADMIN_GET_ALL_CANCEL_REASON_FAIL,
	API_ADMIN_GET_CANCEL_REASON,
	API_ADMIN_GET_CANCEL_REASON_SUCCESS,
	API_ADMIN_GET_CANCEL_REASON_FAIL,
	ADMIN_INIT_NEW_CANCEL_REASON,
	ADMIN_RESET_FOCUS_CANCEL_REASON,
	API_ADMIN_POST_CANCEL_REASON,
	API_ADMIN_POST_CANCEL_REASON_FAIL,
	API_ADMIN_POST_CANCEL_REASON_SUCCESS,
	API_ADMIN_PATCH_CANCEL_REASON,
	API_ADMIN_PATCH_CANCEL_REASON_FAIL,
	API_ADMIN_PATCH_CANCEL_REASON_SUCCESS,
	API_ADMIN_DELETE_CANCEL_REASON,
	API_ADMIN_DELETE_CANCEL_REASON_SUCCESS,
	API_ADMIN_DELETE_CANCEL_REASON_FAIL,
	API_ADMIN_GET_CANCEL_REASON_GROUPS_SUCCESS,
	API_ADMIN_GET_CANCEL_REASON_GROUPS_FAIL,
} from "actions/cancelReason";
import {
	API_ADMIN_DELETE_CENTER,
	API_ADMIN_DELETE_CENTER_SUCCESS,
	API_ADMIN_DELETE_CENTER_FAIL,
	API_ADMIN_GET_ALL_CENTER,
	API_ADMIN_GET_ALL_CENTER_SUCCESS,
	API_ADMIN_GET_ALL_CENTER_FAIL,
	API_ADMIN_PATCH_CENTER,
	API_ADMIN_PATCH_CENTER_FAIL,
	API_ADMIN_PATCH_CENTER_SUCCESS,
	API_ADMIN_POST_CENTER,
	API_ADMIN_POST_CENTER_FAIL,
	API_ADMIN_POST_CENTER_SUCCESS,
	ADMIN_INIT_NEW_CENTER,
	ADMIN_RESET_FOCUS_CENTER,
	API_ADMIN_GET_CENTER,
	API_ADMIN_GET_CENTER_FAIL,
	API_ADMIN_GET_CENTER_SUCCESS,
	API_ADMIN_IMPORT_CENTER,
	API_ADMIN_IMPORT_CENTER_FAIL,
	API_ADMIN_IMPORT_CENTER_SUCCESS,
	API_GET_CENTERS_MY_RDV_SUCCESS,
} from "actions/center";

import {
	API_ADMIN_DELETE_BOX,
	API_ADMIN_DELETE_BOX_SUCCESS,
	API_ADMIN_DELETE_BOX_FAIL,
	API_ADMIN_GET_ALL_BOXES,
	API_ADMIN_GET_ALL_BOXES_SUCCESS,
	API_ADMIN_GET_ALL_BOXES_FAIL,
	API_ADMIN_PATCH_BOX,
	API_ADMIN_PATCH_BOX_FAIL,
	API_ADMIN_PATCH_BOX_SUCCESS,
	API_ADMIN_POST_BOX,
	API_ADMIN_POST_BOX_FAIL,
	API_ADMIN_POST_BOX_SUCCESS,
	ADMIN_INIT_NEW_BOX,
	ADMIN_RESET_FOCUS_BOX,
	API_ADMIN_GET_BOX,
	API_ADMIN_GET_BOX_FAIL,
	API_ADMIN_GET_BOX_SUCCESS,
} from "actions/box";

import {
	API_ADMIN_DELETE_SCANNER,
	API_ADMIN_DELETE_SCANNER_SUCCESS,
	API_ADMIN_DELETE_SCANNER_FAIL,
	API_ADMIN_GET_ALL_SCANNERS,
	API_ADMIN_GET_ALL_SCANNERS_SUCCESS,
	API_ADMIN_GET_ALL_SCANNERS_FAIL,
	API_ADMIN_PATCH_SCANNER,
	API_ADMIN_PATCH_SCANNER_FAIL,
	API_ADMIN_PATCH_SCANNER_SUCCESS,
	API_ADMIN_POST_SCANNER,
	API_ADMIN_POST_SCANNER_FAIL,
	API_ADMIN_POST_SCANNER_SUCCESS,
	ADMIN_INIT_NEW_SCANNER,
	ADMIN_RESET_FOCUS_SCANNER,
	API_ADMIN_GET_SCANNER,
	API_ADMIN_GET_SCANNER_FAIL,
	API_ADMIN_GET_SCANNER_SUCCESS,
} from "actions/scanner";

import {
	API_ADMIN_DELETE_SAMPLE_TYPE,
	API_ADMIN_DELETE_SAMPLE_TYPE_SUCCESS,
	API_ADMIN_DELETE_SAMPLE_TYPE_FAIL,
	API_ADMIN_GET_ALL_SAMPLE_TYPE,
	API_ADMIN_GET_ALL_SAMPLE_TYPE_SUCCESS,
	API_ADMIN_GET_ALL_SAMPLE_TYPE_FAIL,
	API_ADMIN_PATCH_SAMPLE_TYPE,
	API_ADMIN_PATCH_SAMPLE_TYPE_FAIL,
	API_ADMIN_PATCH_SAMPLE_TYPE_SUCCESS,
	API_ADMIN_POST_SAMPLE_TYPE,
	API_ADMIN_POST_SAMPLE_TYPE_FAIL,
	API_ADMIN_POST_SAMPLE_TYPE_SUCCESS,
	ADMIN_INIT_NEW_SAMPLE_TYPE,
	ADMIN_RESET_FOCUS_SAMPLE_TYPE,
	API_ADMIN_GET_SAMPLE_TYPE,
	API_ADMIN_GET_SAMPLE_TYPE_FAIL,
	API_ADMIN_GET_SAMPLE_TYPE_SUCCESS,
} from "actions/sampleType";
import { ErrorAction, errorHandler } from "utils/error";
import { API_GET_ANALYSIS_IMPORT, API_GET_ANALYSIS_IMPORT_FAIL, API_GET_ANALYSIS_IMPORT_SUCCESS } from "actions/analysisService";
import {
	API_ADMIN_DELETE_SERVIPAY_TERMINAL,
	API_ADMIN_DELETE_SERVIPAY_TERMINAL_SUCCESS,
	API_ADMIN_DELETE_SERVIPAY_TERMINAL_FAIL,
	API_ADMIN_GET_ALL_SERVIPAY_TERMINAL,
	API_ADMIN_GET_ALL_SERVIPAY_TERMINAL_SUCCESS,
	API_ADMIN_GET_ALL_SERVIPAY_TERMINAL_FAIL,
	API_ADMIN_PATCH_SERVIPAY_TERMINAL,
	API_ADMIN_PATCH_SERVIPAY_TERMINAL_FAIL,
	API_ADMIN_PATCH_SERVIPAY_TERMINAL_SUCCESS,
	API_ADMIN_POST_SERVIPAY_TERMINAL,
	API_ADMIN_POST_SERVIPAY_TERMINAL_FAIL,
	API_ADMIN_POST_SERVIPAY_TERMINAL_SUCCESS,
	ADMIN_INIT_NEW_SERVIPAY_TERMINAL,
	ADMIN_RESET_FOCUS_SERVIPAY_TERMINAL,
	API_ADMIN_GET_SERVIPAY_TERMINAL,
	API_ADMIN_GET_SERVIPAY_TERMINAL_FAIL,
	API_ADMIN_GET_SERVIPAY_TERMINAL_SUCCESS,
} from "actions/servipayTerminal";

import {
	API_ADMIN_GET_ALL_PARTNERS,
	API_ADMIN_GET_ALL_PARTNERS_SUCCESS,
	API_ADMIN_GET_ALL_PARTNERS_FAIL,
	API_ADMIN_POST_PARTNER,
	API_ADMIN_POST_PARTNER_SUCCESS,
	API_ADMIN_POST_PARTNER_FAIL,
	API_ADMIN_PATCH_PARTNER,
	API_ADMIN_PATCH_PARTNER_SUCCESS,
	API_ADMIN_PATCH_PARTNER_FAIL,
	API_ADMIN_DELETE_PARTNER,
	API_ADMIN_DELETE_PARTNER_SUCCESS,
	API_ADMIN_DELETE_PARTNER_FAIL,
	ADMIN_INIT_NEW_PARTNER,
	ADMIN_RESET_FOCUS_PARTNER,
	API_ADMIN_GET_PARTNER,
	API_ADMIN_GET_PARTNER_FAIL,
	API_ADMIN_GET_PARTNER_SUCCESS,
} from "actions/partnerCompany";

import { API_GET_CONNECTED_USERS_WS, API_GET_CONNECTED_USERS_WS_SUCCESS } from "actions/websocket";

import {
	API_ADMIN_GET_ALL_CAMPAIGNS,
	API_ADMIN_GET_ALL_CAMPAIGNS_SUCCESS,
	API_ADMIN_GET_ALL_CAMPAIGNS_FAIL,
	API_ADMIN_GET_CAMPAIGN,
	API_ADMIN_GET_CAMPAIGN_SUCCESS,
	API_ADMIN_GET_CAMPAIGN_FAIL,
	ADMIN_INIT_NEW_CAMPAIGN,
	ADMIN_RESET_FOCUS_CAMPAIGN,
	API_ADMIN_POST_CAMPAIGN,
	API_ADMIN_POST_CAMPAIGN_FAIL,
	API_ADMIN_POST_CAMPAIGN_SUCCESS,
	API_ADMIN_PATCH_CAMPAIGN,
	API_ADMIN_PATCH_CAMPAIGN_FAIL,
	API_ADMIN_PATCH_CAMPAIGN_SUCCESS,
	API_ADMIN_DELETE_CAMPAIGN,
	API_ADMIN_DELETE_CAMPAIGN_FAIL,
	API_ADMIN_DELETE_CAMPAIGN_SUCCESS,
	API_GET_CAMPAIGNS_RECORDS_PAGE,
	API_GET_CAMPAIGNS_RECORDS_PAGE_SUCCESS,
} from "actions/campaign";
import { DEFAULT_CLIENT, V2_CLIENT } from "config/clientConstants";
import { getVersion as getUserServiceVersion } from "services/user";
import { getVersion as getQuestionLibraryVersion } from "services/questionLibrary";
import { getVersion as getAnswerOptionLibraryVersion } from "services/answerOptionLibrary";
import { getVersion as getAnalysisLibraryVersion } from "services/analysisLibrary";
import { getVersion as getCompanyServiceVersion } from "services/company";
import { adaptCompanyPayloadResponse } from "./company";
import { getVersion as getCampaignServiceVersion } from "services/campaign";
import { adaptCampaignPayloadResponse } from "./campaign";
import { getVersion as getBoxServiceVersion } from "services/box";
import { getVersion as getLaboratoryServiceVersion } from "services/laboratory";

const toNumber = (value) => {
	if (value === null || value === undefined) return value;
	const num = typeof value === 'string' ? parseFloat(value) : Number(value);
	return isNaN(num) ? value : num;
};

const adaptBoxResponse = (box, currentClient) => {
	try {
		if (!box || currentClient !== V2_CLIENT) {
			return box;
		}

		const adapted = { ...box };

		// Keep camelCase (used by UI), but also expose snake_case for compatibility.
		if (adapted.liveCallNumber !== undefined && adapted.live_call_number === undefined) {
			adapted.live_call_number = adapted.liveCallNumber;
		}
		if (adapted.live_call_number !== undefined && adapted.liveCallNumber === undefined) {
			adapted.liveCallNumber = adapted.live_call_number;
		}

		return adapted;
	} catch (error) {
		console.error("Error in adaptBoxResponse:", error);
		return box;
	}
};

const adaptBoxPayloadResponse = (action, actionType) => {
	try {
		const payload = action.payload || {};
		const data = payload.data;
		const currentClient = action.meta?.previousAction?.payload?.client || getBoxServiceVersion(actionType).currentClient;

		if (!data) {
			return payload;
		}

		if (currentClient === V2_CLIENT) {
			if (Array.isArray(data)) {
				return {
					...payload,
					data: data.map((item) => adaptBoxResponse(item, currentClient)),
				};
			}

			if (typeof data === "object") {
				return {
					...payload,
					data: adaptBoxResponse(data, currentClient),
				};
			}
		}

		return payload;
	} catch (error) {
		console.error("Error in adaptBoxPayloadResponse:", error);
		return action.payload || {};
	}
};

const adaptLaboratoryResponse = (laboratory, currentClient) => {
	try {
		if (!laboratory || currentClient !== V2_CLIENT) {
			return laboratory;
		}

		const adapted = { ...laboratory };

		if (adapted.ipRange !== undefined && adapted.ip_range === undefined) {
			adapted.ip_range = adapted.ipRange;
		}
		if (adapted.folderNumFormat !== undefined && adapted.folder_num_format === undefined) {
			adapted.folder_num_format = adapted.folderNumFormat;
		}
		if (adapted.labParamGroup === undefined) {
			adapted.labParamGroup = null;
		}

		return adapted;
	} catch (error) {
		console.error("Error in adaptLaboratoryResponse:", error);
		return laboratory;
	}
};

const adaptLaboratoryPayloadResponse = (action, actionType) => {
	try {
		const payload = action.payload || {};
		const data = payload.data;
		const currentClient = action.meta?.previousAction?.payload?.client || getLaboratoryServiceVersion(actionType).currentClient;

		if (!data) {
			return payload;
		}

		if (currentClient === V2_CLIENT) {
			if (Array.isArray(data)) {
				return {
					...payload,
					data: data.map((item) => adaptLaboratoryResponse(item, currentClient)),
				};
			}

			if (typeof data === "object") {
				return {
					...payload,
					data: adaptLaboratoryResponse(data, currentClient),
				};
			}
		}

		return payload;
	} catch (error) {
		console.error("Error in adaptLaboratoryPayloadResponse:", error);
		return action.payload || {};
	}
};

const adaptQuestionLibraryResponse = (question, currentClient) => {
	try {
		if (!question || currentClient !== V2_CLIENT) {
			return question;
		}

		const adapted = { ...question };

		const fieldMap = {
			silCode: 'sil_code',
			codeComment: 'code_comment',
			numberRecords: 'number_records',
			autoSelectLastRecord: 'auto_select_last_record',
			autoAnswer: 'auto_answer',
			optionalResponse: 'optional_response',
			takeNumberBeforeDisplay: 'take_number_before_display',
			addingFreeInput: 'adding_free_input',
			answerOptions: 'answer_options',
		};

		Object.keys(fieldMap).forEach((camelKey) => {
			if (adapted[camelKey] !== undefined && adapted[fieldMap[camelKey]] === undefined) {
				adapted[fieldMap[camelKey]] = adapted[camelKey];
			}
		});

		if (adapted.answerOptions && Array.isArray(adapted.answerOptions)) {
			adapted.answer_options = adapted.answerOptions.map((option) => {
				const adaptedOption = { ...option };
				if (adaptedOption.questionId !== undefined && adaptedOption.questionId !== null && adaptedOption.question_id === undefined) {
					adaptedOption.question_id = toNumber(adaptedOption.questionId);
				}
				if (adaptedOption.answerOptionLibraryId !== undefined && adaptedOption.answerOptionLibraryId !== null && adaptedOption.answer_option_library_id === undefined) {
					adaptedOption.answer_option_library_id = toNumber(adaptedOption.answerOptionLibraryId);
				}
				return adaptedOption;
			});
		}

		return adapted;
	} catch (error) {
		console.error('Error in adaptQuestionLibraryResponse:', error);
		return question;
	}
};

const adaptQuestionLibraryPayloadResponse = (action, actionType) => {
	try {
		const payload = action.payload || {};
		const data = payload.data;
		const currentClient = action.meta?.previousAction?.payload?.client || getQuestionLibraryVersion(actionType).currentClient;

		if (!data) {
			return payload;
		}

		if (currentClient === V2_CLIENT) {
			if (Array.isArray(data)) {
				const adaptedData = data.map((item) => adaptQuestionLibraryResponse(item, currentClient));
				return {
					...payload,
					data: adaptedData,
				};
			} else if (typeof data === 'object' && data !== null) {
				const adaptedData = adaptQuestionLibraryResponse(data, currentClient);
				return {
					...payload,
					data: adaptedData,
				};
			}
		}

		return payload;
	} catch (error) {
		console.error('Error in adaptQuestionLibraryPayloadResponse:', error);
		return action.payload || {};
	}
};

const adaptAnswerOptionLibraryResponse = (answerOption, currentClient) => {
	try {
		if (!answerOption || currentClient !== V2_CLIENT) {
			return answerOption;
		}

		const adapted = { ...answerOption };

		const fieldMap = {
			silCode: 'sil_code',
			codeComment: 'code_comment',
			idCa: 'id_ca',
			addText: 'add_text',
		};

		Object.keys(fieldMap).forEach((camelKey) => {
			if (adapted[camelKey] !== undefined && adapted[fieldMap[camelKey]] === undefined) {
				adapted[fieldMap[camelKey]] = adapted[camelKey];
			}
		});

		if (adapted.idCa !== undefined && adapted.idCa !== null && adapted.id_ca === undefined) {
			adapted.id_ca = toNumber(adapted.idCa);
		}

		return adapted;
	} catch (error) {
		console.error('Error in adaptAnswerOptionLibraryResponse:', error);
		return answerOption;
	}
};

const adaptAnswerOptionLibraryPayloadResponse = (action, actionType) => {
	try {
		const payload = action.payload || {};
		const data = payload.data;
		const currentClient = action.meta?.previousAction?.payload?.client || getAnswerOptionLibraryVersion(actionType).currentClient;

		if (!data) {
			return payload;
		}

		if (currentClient === V2_CLIENT) {
			if (Array.isArray(data)) {
				const adaptedData = data.map((item) => adaptAnswerOptionLibraryResponse(item, currentClient));
				return {
					...payload,
					data: adaptedData,
				};
			} else if (typeof data === 'object' && data !== null) {
				const adaptedData = adaptAnswerOptionLibraryResponse(data, currentClient);
				return {
					...payload,
					data: adaptedData,
				};
			}
		}

		return payload;
	} catch (error) {
		console.error('Error in adaptAnswerOptionLibraryPayloadResponse:', error);
		return action.payload || {};
	}
};

const adaptAnalysisLibraryResponse = (analysis, currentClient) => {
	try {
		if (!analysis || currentClient !== V2_CLIENT) {
			return analysis;
		}

		const adapted = { ...analysis };

		const fieldMap = {
			silCode: 'sil_code',
			catalogCode: 'catalog_code',
			codeComment: 'code_comment',
			silImport: 'sil_import',
			colorPriority: 'color_priority',
			displayOrder: 'display_order',
			takingNote: 'taking_note',
			specialDiet: 'special_diet',
			homeProhibited: 'home_prohibited',
			homeNotRecommended: 'home_not_recommended',
			lightProtected: 'light_protected',
			requiredConsent: 'required_consent',
			pretreatmentStability: 'pretreatment_stability',
			pretreatmentDelay: 'pretreatment_delay',
			pretreatmentNote: 'pretreatment_note',
			pretreatmentUrgent: 'pretreatment_urgent',
			pretreatmentType: 'pretreatment_type',
			ptTransport: 'pt_transport',
			analysisAdditionTimeLimit: 'analysis_addition_time_limit',
			pretreatmentCentrifugeProg: 'pretreatment_centrifuge_prog',
			pipetteVolume: 'pipette_volume',
			volumeForDilution: 'volume_for_dilution',
			deadSpace: 'dead_space',
			treatmentDayMonday: 'treatment_day_monday',
			treatmentDayTuesday: 'treatment_day_tuesday',
			treatmentDayWednesday: 'treatment_day_wednesday',
			treatmentDayThursday: 'treatment_day_thursday',
			treatmentDayFriday: 'treatment_day_friday',
			treatmentDaySaturday: 'treatment_day_saturday',
			treatmentDaySunday: 'treatment_day_sunday',
			timeToResults: 'time_to_results',
			clinicalInterest: 'clinical_interest',
			noteForPatient: 'note_for_patient',
			labelEn: 'label_en',
			synonymousEn: 'synonymous_en',
			commentPreprocessingEn: 'comment_preprocessing_en',
			commentSampleEn: 'comment_sample_en',
			commentDietEn: 'comment_diet_en',
			labelDe: 'label_de',
			synonymousDe: 'synonymous_de',
			commentPreprocessingDe: 'comment_preprocessing_de',
			commentSampleDe: 'comment_sample_de',
			commentDietDe: 'comment_diet_de',
			resultsPrescriberOnly: 'results_prescriber_only',
			createdDate: 'created_date',
			updatedDate: 'updated_date',
			startDate: 'start_date',
			endDate: 'end_date',
			catalogId: 'catalog_id',
			isAvailableWithoutCatalog: 'isAvailableWithoutCatalog',
			bionextPrice: 'bionext_price',
			waitingTimeBeforeSampling: 'waiting_time_before_sampling',
			weightForMotivation: 'weight_for_motivation',
			isCovid: 'is_covid',
			identityCheck: 'identity_check',
			calculatingCost: 'calculating_cost',
		};

		Object.keys(fieldMap).forEach((camelKey) => {
			if (adapted[camelKey] !== undefined && adapted[fieldMap[camelKey]] === undefined) {
				adapted[fieldMap[camelKey]] = adapted[camelKey];
			}
		});

		if (adapted.catalogId !== undefined && adapted.catalogId !== null && adapted.catalog_id === undefined) {
			adapted.catalog_id = toNumber(adapted.catalogId);
		}

		return adapted;
	} catch (error) {
		console.error('Error in adaptAnalysisLibraryResponse:', error);
		return analysis;
	}
};

const adaptAnalysisLibraryPayloadResponse = (action, actionType) => {
	try {
		const payload = action.payload || {};
		const data = payload.data;
		const currentClient = action.meta?.previousAction?.payload?.client || getAnalysisLibraryVersion(actionType).currentClient;

		if (!data) {
			return payload;
		}

		if (currentClient === V2_CLIENT) {
			if (Array.isArray(data)) {
				const adaptedData = data.map((item) => adaptAnalysisLibraryResponse(item, currentClient));
				return {
					...payload,
					data: adaptedData,
				};
			} else if (typeof data === 'object' && data !== null) {
				const adaptedData = adaptAnalysisLibraryResponse(data, currentClient);
				return {
					...payload,
					data: adaptedData,
				};
			}
		}

		return payload;
	} catch (error) {
		console.error('Error in adaptAnalysisLibraryPayloadResponse:', error);
		return action.payload || {};
	}
};

const initialState = {
	users: {
		list: {
			loading: false,
			data: [],
		},
		focus: {
			loading: false,
			data: null,
		},
	},
	samplers: {
		list: { loading: false, data: [] },
	},
	analyses: {
		list: {
			loading: false,
			data: [],
		},
		focus: {
			loading: false,
			data: null,
		},
	},
	tubes: {
		list: {
			loading: false,
			data: [],
		},
		focus: {
			loading: false,
			data: null,
		},
		pictos: {
			loading: false,
			data: null,
		},
	},
	questions: {
		list: {
			loading: false,
			data: [],
		},
		focus: {
			loading: false,
			data: null,
		},
	},
	motivations: {
		list: {
			loading: false,
			data: [],
		},
		focus: {
			loading: false,
			data: null,
		},
	},
	systematicQuestions: {
		list: {
			loading: false,
			data: [],
		},
		focus: {
			loading: false,
			data: null,
		},
	},
	answers: {
		list: {
			loading: false,
			data: [],
		},
		focus: {
			loading: false,
			data: null,
		},
	},
	general: {
		focus: {
			loading: false,
			data: {},
		},
	},
	analysesPacks: {
		list: {
			loading: false,
			data: [],
		},
		focus: {
			loading: false,
			data: null,
		},
	},
	insurances: {
		list: {
			loading: false,
			data: [],
		},
		focus: {
			loading: false,
			data: null,
		},
	},
	documentTypes: {
		list: {
			loading: false,
			data: [],
		},
		focus: {
			loading: false,
			data: null,
		},
	},
	specialRegimes: {
		list: {
			loading: false,
			data: [],
		},
		focus: {
			loading: false,
			data: null,
		},
	},
	specialties: {
		list: {
			loading: false,
			data: [],
		},
		focus: {
			loading: false,
			data: null,
		},
	},
	companies: {
		list: {
			loading: false,
			data: [],
		},
		focus: {
			loading: false,
			data: null,
		},
	},
	labParamGroups: {
		list: {
			loading: false,
			data: [],
		},
		focus: {
			loading: false,
			data: null,
		},
	},
	laboratories: {
		list: {
			loading: false,
			data: [],
		},
		focus: {
			loading: false,
			data: null,
		},
	},
	emergencyReasons: {
		list: {
			loading: false,
			data: [],
		},
		focus: {
			loading: false,
			data: null,
		},
	},
	validationPausedReasons: {
		list: {
			loading: false,
			data: [],
		},
		focus: {
			loading: false,
			data: null,
		},
	},
	consentRefusalReasons: {
		list: {
			loading: false,
			data: [],
		},
		focus: {
			loading: false,
			data: null,
		},
	},
	contactComments: {
		list: {
			loading: false,
			data: [],
		},
		focus: {
			loading: false,
			data: null,
		},
	},
	tubeReasons: {
		list: {
			loading: false,
			data: [],
		},
		focus: {
			loading: false,
			data: null,
		},
		groups: [],
	},
	cancelReasons: {
		list: {
			loading: false,
			data: [],
		},
		focus: {
			loading: false,
			data: null,
		},
		groups: [],
	},
	centers: {
		list: {
			loading: false,
			data: [],
		},
		focus: {
			loading: false,
			data: null,
		},
		groups: [],
		myRdv: [],
	},
	boxes: {
		list: {
			loading: false,
			data: [],
		},
		focus: {
			loading: false,
			data: null,
		},
	},
	campaigns: {
		list: {
			loading: false,
			data: [],
		},
		focus: {
			loading: false,
			data: null,
		},
		packs: { loading: false, data: [] },
	},
	deposits: {
		packs: { loading: false, data: [] },
	},
	scanners: {
		list: {
			loading: false,
			data: [],
		},
		focus: {
			loading: false,
			data: null,
		},
	},
	sampleTypes: {
		list: {
			loading: false,
			data: [],
		},
		focus: {
			loading: false,
			data: null,
		},
		groups: [],
	},
	catalog: {
		loading: false,
	},
	servipayTerminals: {
		list: {
			loading: false,
			data: [],
		},
		focus: {
			loading: false,
			data: null,
		},
	},
	connected: {
		list: {
			loading: false,
			data: [],
		},
	},
	analysesPacksPrescriber: {
		list: {
			loading: false,
			data: [],
		},
		prescribers: {
			list: [],
			focus: {
				loading: false,
				data: null,
			},
		},
		prescriptionsDetails: [],
	},
	partners: {
		list: {
			loading: false,
			data: [],
		},
		focus: {
			loading: false,
			data: null,
		},
	},
};

const admin = createReducer(initialState, {
	/** USERS **/
	[API_ADMIN_GET_ALL_USER]: (state, action) => {
		state.users.list.loading = true;
	},

	[API_ADMIN_GET_ALL_USER_SUCCESS]: (state, action) => {
		state.users.list.loading = false;
		const version = getUserServiceVersion(API_ADMIN_GET_ALL_USER);
		const isV2 = version.currentClient === V2_CLIENT;
		const data = isV2 && action.payload && action.payload.data && action.payload.data.items ? action.payload.data.items : action.payload.data;
		state.users.list.data = data;
	},

	[API_ADMIN_GET_USER_SUCCESS]: (state, action) => {
		state.users.focus.loading = false;
		state.users.focus.data = action.payload.data;
	},

	[API_ADMIN_POST_USER]: (state, action) => {
		state.users.list.loading = true;
	},

	[API_ADMIN_POST_USER_FAIL]: (state, action) => {
		errorHandler("Utilisateur", ErrorAction.CREATE, action.error);
		state.users.list.loading = false;
	},

	[API_ADMIN_POST_USER_SUCCESS]: (state, action) => {
		state.users.focus.loading = false;
		state.users.focus.data = action.payload.data;

		state.users.list.data.push(action.payload.data);
		state.users.list.loading = false;
	},

	[API_ADMIN_PATCH_USER]: (state, action) => {
		state.users.list.loading = true;
	},

	[API_ADMIN_PATCH_USER_FAIL]: (state, action) => {
		state.users.list.loading = false;
		errorHandler("Utilisateur", ErrorAction.UPDATE, action.error);
	},

	[API_ADMIN_PATCH_USER_SUCCESS]: (state, action) => {
		state.users.focus.loading = false;
		state.users.focus.data = action.payload.data;

		let index = state.users.list.data.findIndex((i) => i.id === action.payload.data.id);

		state.users.list.data[index] = action.payload.data;
		state.users.list.loading = false;
	},

	[API_ADMIN_DELETE_USER]: (state, action) => {
		state.users.list.loading = true;
	},

	[API_ADMIN_DELETE_USER_FAIL]: (state, action) => {
		state.users.list.loading = false;
		errorHandler("Utilisateur", ErrorAction.DELETE, action.error);
	},

	[API_ADMIN_DELETE_USER_SUCCESS]: (state, action) => {
		let { data } = state.users.list;
		state.users.list.loading = false;
		const payloadId = action.payload && action.payload.data ? action.payload.data.id : null;
		let deletedId = payloadId;
		if (!deletedId) {
			const url = action.meta && action.meta.previousAction && action.meta.previousAction.payload && action.meta.previousAction.payload.request ? action.meta.previousAction.payload.request.url : "";
			const lastSegment = url.split("/").filter(Boolean).pop();
			const parsed = lastSegment && !isNaN(Number(lastSegment)) ? Number(lastSegment) : null;
			deletedId = parsed;
		}
		if (deletedId != null) {
			const idx = data.findIndex((i) => i.id === deletedId);
			if (idx !== -1) {
				data.splice(idx, 1);
			}
		}
		state.users.list.data = data;
		state.users.focus.data = null;
	},

	[ADMIN_RESET_FOCUS_USER]: (state, action) => {
		state.users.focus.data = null;
		state.users.focus.loading = false;
	},

	[ADMIN_INIT_NEW_USER]: (state, action) => {
		state.users.focus.data = {};
		state.users.focus.loading = false;
	},

	[API_ADMIN_GET_SAMPLERS_USER]: (state, action) => {
		state.samplers.data = null;
		state.samplers.loading = true;
	},
	[API_ADMIN_GET_SAMPLERS_USER_SUCCESS]: (state, action) => {
		state.samplers.data = action.payload.data;
		state.samplers.loading = false;
	},
	[API_ADMIN_GET_SAMPLERS_USER_FAIL]: (state, action) => {
		errorHandler("Liste des préleveurs", ErrorAction.READ, action.error);
		state.samplers.data = null;
		state.samplers.loading = false;
	},

	/** GENERAL PARAMETERS **/
	[API_ADMIN_GET_ALL_GENERALPARAMETER]: (state, action) => {
		state.general.focus.loading = true;
	},
	[API_ADMIN_GET_ALL_GENERALPARAMETER_FAIL]: (state, action) => {
		errorHandler("Paramètres généraux", ErrorAction.READ, action.error);
		state.general.focus.loading = false;
	},
	[API_ADMIN_GET_ALL_GENERALPARAMETER_SUCCESS]: (state, action) => {
		state.general.focus.loading = false;
		state.general.focus.data = action.payload.data;
	},
	[API_ADMIN_PATCH_GENERALPARAMETER]: (state, action) => {
		state.general.focus.loading = true;
	},
	[API_ADMIN_PATCH_GENERALPARAMETER_FAIL]: (state, action) => {
		errorHandler("Paramètres généraux", ErrorAction.UPDATE, action.error);
		state.general.focus.loading = false;
	},
	[API_ADMIN_PATCH_GENERALPARAMETER_SUCCESS]: (state, action) => {
		state.general.focus.loading = false;
		state.general.focus.data = action.payload.data;
	},

	/** ANALYSES **/
	[API_ADMIN_GET_ALL_ANALYSISLIBRARY]: (state, action) => {
		state.analyses.list.loading = true;
	},

	[API_ADMIN_GET_ALL_ANALYSISLIBRARY_SUCCESS]: (state, action) => {
		const adaptedPayload = adaptAnalysisLibraryPayloadResponse(action, API_ADMIN_GET_ALL_ANALYSISLIBRARY);
		state.analyses.list = {
			loading: false,
			data: adaptedPayload.data || [],
		};
	},
	[API_ADMIN_GET_ALL_ANALYSISLIBRARY_FAIL]: (state, action) => {
		state.analyses.list = {
			loading: false,
		};
	},

	[API_ADMIN_GET_ANALYSISLIBRARY_SUCCESS]: (state, action) => {
		const adaptedPayload = adaptAnalysisLibraryPayloadResponse(action, API_ADMIN_GET_ANALYSISLIBRARY);
		const currentClient = action.meta?.previousAction?.payload?.client || getAnalysisLibraryVersion(API_ADMIN_GET_ANALYSISLIBRARY).currentClient;
		state.analyses.focus = {
			loading: false,
			data: adaptedPayload.data ? adaptAnalysisLibraryResponse(adaptedPayload.data, currentClient) : null,
		};
	},

	[API_ADMIN_POST_ANALYSISLIBRARY]: (state, action) => {
		state.analyses.list.loading = true;
	},

	[API_ADMIN_POST_ANALYSISLIBRARY_FAIL]: (state, action) => {
		errorHandler("Catalogue d'analyse", ErrorAction.CREATE, action.error);
		state.analyses.list.loading = false;
	},

	[API_ADMIN_POST_ANALYSISLIBRARY_SUCCESS]: (state, action) => {
		const adaptedPayload = adaptAnalysisLibraryPayloadResponse(action, API_ADMIN_POST_ANALYSISLIBRARY);
		const currentClient = action.meta?.previousAction?.payload?.client || getAnalysisLibraryVersion(API_ADMIN_POST_ANALYSISLIBRARY).currentClient;
		const adaptedData = adaptedPayload.data ? adaptAnalysisLibraryResponse(adaptedPayload.data, currentClient) : null;

		state.analyses.focus.loading = false;
		state.analyses.focus.data = adaptedData;

		if (adaptedData) {
			state.analyses.list.data.push(adaptedData);
		}
		state.analyses.list.loading = false;
	},

	[API_ADMIN_PATCH_ANALYSISLIBRARY]: (state, action) => {
		state.analyses.list.loading = true;
	},

	[API_ADMIN_PATCH_ANALYSISLIBRARY_FAIL]: (state, action) => {
		errorHandler("Catalogue d'analyse", ErrorAction.UPDATE, action.error);
		state.analyses.list.loading = false;
	},

	[API_ADMIN_PATCH_ANALYSISLIBRARY_SUCCESS]: (state, action) => {
		toast.success("L'analyse a été modifiée");

		const adaptedPayload = adaptAnalysisLibraryPayloadResponse(action, API_ADMIN_PATCH_ANALYSISLIBRARY);
		const currentClient = action.meta?.previousAction?.payload?.client || getAnalysisLibraryVersion(API_ADMIN_PATCH_ANALYSISLIBRARY).currentClient;
		const adaptedData = adaptedPayload.data ? adaptAnalysisLibraryResponse(adaptedPayload.data, currentClient) : null;

		state.analyses.focus.loading = false;
		state.analyses.focus.data = adaptedData;

		if (adaptedData) {
			let index = state.analyses.list.data.findIndex((i) => i.id === adaptedData.id);
			if (index >= 0) {
				state.analyses.list.data[index] = adaptedData;
			}
		}
		state.analyses.list.loading = false;
	},

	[API_ADMIN_DELETE_ANALYSISLIBRARY]: (state, action) => {
		state.analyses.list.loading = true;
	},

	[API_ADMIN_DELETE_ANALYSISLIBRARY_FAIL]: (state, action) => {
		errorHandler("Catalogue d'analyse", ErrorAction.DELETE, action.error);
		state.analyses.list.loading = false;
	},

	[API_ADMIN_DELETE_ANALYSISLIBRARY_SUCCESS]: (state, action) => {
		toast.success("L'analyse a été supprimée");

		let { data } = state.analyses.list;
		state.analyses.list.loading = false;
		data.splice(
			data.findIndex((i) => i.id === action.payload.data.id),
			1
		);

		state.analyses.list.data = data;
		state.analyses.focus.data = null;
	},

	[ADMIN_RESET_FOCUS_ANALYSISLIBRARY]: (state, action) => {
		state.analyses.focus.data = null;
		state.analyses.focus.loading = false;
	},

	[ADMIN_INIT_NEW_ANALYSISLIBRARY]: (state, action) => {
		state.analyses.focus.data = {};
		state.analyses.focus.loading = false;
	},

	/** TUBES **/
	[API_ADMIN_GET_ALL_TUBELIBRARY]: (state, action) => {
		state.tubes.list.loading = true;
	},

	[API_ADMIN_GET_ALL_TUBELIBRARY_SUCCESS]: (state, action) => {
		state.tubes.list = {
			loading: false,
			data: action.payload.data,
		};
	},
	[API_ADMIN_GET_ALL_TUBELIBRARY_FAIL]: (state, action) => {
		state.tubes.list = {
			loading: false,
		};
	},

	[API_ADMIN_GET_TUBELIBRARY_SUCCESS]: (state, action) => {
		state.tubes.focus = {
			loading: false,
			data: action.payload.data,
		};
	},

	[ADMIN_RESET_FOCUS_TUBELIBRARY]: (state, action) => {
		state.tubes.focus.data = null;
		state.tubes.focus.loading = false;
	},

	[ADMIN_INIT_NEW_TUBELIBRARY]: (state, action) => {
		state.tubes.focus.data = {};
		state.tubes.focus.loading = false;
	},

	[ADMIN_UPDATE_FOCUS_PHOTO_TUBELIBRARY]: (state, action) => {
		state.tubes.focus.data.photo = action.payload.data;
	},

	/** QUESTIONS **/
	[API_ADMIN_GET_ALL_QUESTIONLIBRARY]: (state, action) => {
		state.questions.list.loading = true;
	},

	[API_ADMIN_GET_ALL_QUESTIONLIBRARY_SUCCESS]: (state, action) => {
		const adaptedPayload = adaptQuestionLibraryPayloadResponse(action, API_ADMIN_GET_ALL_QUESTIONLIBRARY);
		state.questions.list = {
			loading: false,
			data: adaptedPayload.data || [],
		};
	},
	[API_ADMIN_GET_ALL_QUESTIONLIBRARY_FAIL]: (state, action) => {
		state.questions.list = {
			loading: false,
		};
	},

	[API_ADMIN_GET_QUESTIONLIBRARY_SUCCESS]: (state, action) => {
		const adaptedPayload = adaptQuestionLibraryPayloadResponse(action, API_ADMIN_GET_QUESTIONLIBRARY);
		const currentClient = action.meta?.previousAction?.payload?.client || getQuestionLibraryVersion(API_ADMIN_GET_QUESTIONLIBRARY).currentClient;
		state.questions.focus = {
			loading: false,
			data: adaptedPayload.data ? adaptQuestionLibraryResponse(adaptedPayload.data, currentClient) : null,
		};
	},

	[API_ADMIN_POST_QUESTIONLIBRARY]: (state, action) => {
		state.questions.list.loading = true;
	},

	[API_ADMIN_POST_QUESTIONLIBRARY_FAIL]: (state, action) => {
		errorHandler("Catalogue de question", ErrorAction.CREATE, action.error);
		state.questions.list.loading = false;
	},

	[API_ADMIN_POST_QUESTIONLIBRARY_SUCCESS]: (state, action) => {
		toast.success("Nouvelle question ajoutée");

		const adaptedPayload = adaptQuestionLibraryPayloadResponse(action, API_ADMIN_POST_QUESTIONLIBRARY);
		const currentClient = action.meta?.previousAction?.payload?.client || getQuestionLibraryVersion(API_ADMIN_POST_QUESTIONLIBRARY).currentClient;
		const adaptedData = adaptedPayload.data ? adaptQuestionLibraryResponse(adaptedPayload.data, currentClient) : null;

		state.questions.focus.loading = false;
		state.questions.focus.data = adaptedData;

		if (adaptedData) {
			state.questions.list.data.push(adaptedData);
		}
		state.questions.list.loading = false;
	},

	[API_ADMIN_PATCH_QUESTIONLIBRARY]: (state, action) => {
		state.questions.list.loading = true;
	},

	[API_ADMIN_PATCH_QUESTIONLIBRARY_FAIL]: (state, action) => {
		errorHandler("Catalogue de question", ErrorAction.UPDATE, action.error);
		state.questions.list.loading = false;
	},

	[API_ADMIN_PATCH_QUESTIONLIBRARY_SUCCESS]: (state, action) => {
		toast.success("La question a été modifiée");

		const adaptedPayload = adaptQuestionLibraryPayloadResponse(action, API_ADMIN_PATCH_QUESTIONLIBRARY);
		const currentClient = action.meta?.previousAction?.payload?.client || getQuestionLibraryVersion(API_ADMIN_PATCH_QUESTIONLIBRARY).currentClient;
		const adaptedData = adaptedPayload.data ? adaptQuestionLibraryResponse(adaptedPayload.data, currentClient) : null;

		state.questions.focus.loading = false;
		state.questions.focus.data = adaptedData;

		if (adaptedData) {
			let index = state.questions.list.data.findIndex((i) => i.id === adaptedData.id);
			if (index >= 0) {
				state.questions.list.data[index] = adaptedData;
			}
		}
		state.questions.list.loading = false;
	},

	[API_ADMIN_DELETE_QUESTIONLIBRARY]: (state, action) => {
		state.questions.list.loading = true;
	},

	[API_ADMIN_DELETE_QUESTIONLIBRARY_FAIL]: (state, action) => {
		errorHandler("Catalogue de question", ErrorAction.DELETE, action.error);
		state.questions.list.loading = false;
	},

	[API_ADMIN_DELETE_QUESTIONLIBRARY_SUCCESS]: (state, action) => {
		toast.success("La question a été supprimée");

		let { data } = state.questions.list;
		state.questions.list.loading = false;
		data.splice(
			data.findIndex((i) => i.id === action.payload.data.id),
			1
		);

		state.questions.list.data = data;
		state.questions.focus.data = null;
	},

	[ADMIN_RESET_FOCUS_QUESTIONLIBRARY]: (state, action) => {
		state.questions.focus.data = null;
		state.questions.focus.loading = false;
	},

	[ADMIN_INIT_NEW_QUESTIONLIBRARY]: (state, action) => {
		state.questions.focus.data = {};
		state.questions.focus.loading = false;
	},

	/** MOTIVATIONS **/
	[API_ADMIN_GET_ALL_MOTIVATIONSLIBRARY_SUCCESS]: (state, action) => {
		state.motivations.list.loading = true;
	},
	[API_ADMIN_GET_ALL_MOTIVATIONSLIBRARY_SUCCESS]: (state, action) => {
		state.motivations.list = {
			loading: false,
			data: action.payload.data,
		};
	},
	[API_ADMIN_GET_ALL_MOTIVATIONSLIBRARY_FAIL]: (state, action) => {
		state.motivations.list = {
			loading: false,
		};
	},
	[API_ADMIN_GET_MOTIVATIONLIBRARY_SUCCESS]: (state, action) => {
		state.motivations.focus = {
			loading: false,
			data: action.payload.data,
		};
	},
	[API_ADMIN_POST_MOTIVATIONLIBRARY]: (state, action) => {
		state.motivations.list.loading = true;
	},

	[API_ADMIN_POST_MOTIVATIONLIBRARY_FAIL]: (state, action) => {
		errorHandler("Catalogue de motivations", ErrorAction.CREATE, action.error);
		state.motivations.list.loading = false;
	},

	[API_ADMIN_POST_MOTIVATIONLIBRARY_SUCCESS]: (state, action) => {
		toast.success("Nouvelle motivation ajoutée");

		state.motivations.focus.loading = false;
		state.motivations.focus.data = action.payload.data;

		state.motivations.list.data.push(action.payload.data);
		state.motivations.list.loading = false;
	},

	[API_ADMIN_PATCH_MOTIVATIONLIBRARY]: (state, action) => {
		state.motivations.list.loading = true;
	},

	[API_ADMIN_PATCH_MOTIVATIONLIBRARY_FAIL]: (state, action) => {
		errorHandler("Catalogue de question", ErrorAction.UPDATE, action.error);
		state.motivations.list.loading = false;
	},

	[API_ADMIN_PATCH_MOTIVATIONLIBRARY_SUCCESS]: (state, action) => {
		toast.success("La motivation a été modifiée");

		state.motivations.focus.loading = false;
		state.motivations.focus.data = action.payload.data;

		let index = state.motivations.list.data.findIndex((i) => i.id === action.payload.data.id);

		state.motivations.list.data[index] = action.payload.data;
		state.motivations.list.loading = false;
	},
	[API_ADMIN_DELETE_MOTIVATIONLIBRARY]: (state, action) => {
		state.motivations.list.loading = true;
	},

	[API_ADMIN_DELETE_MOTIVATIONLIBRARY_FAIL]: (state, action) => {
		errorHandler("Catalogue de motivation", ErrorAction.DELETE, action.error);
		state.motivations.list.loading = false;
	},

	[API_ADMIN_DELETE_MOTIVATIONLIBRARY_SUCCESS]: (state, action) => {
		toast.success("La motivation a été désactivée");

		let { data } = state.motivations.list;
		state.motivations.list.loading = false;
		data.splice(
			data.findIndex((i) => i.id === action.payload.data.id),
			1
		);

		state.motivations.list.data = data;
		state.motivations.focus.data = null;
	},

	[ADMIN_RESET_FOCUS_MOTIVATIONLIBRARY]: (state, action) => {
		state.motivations.focus.data = null;
		state.motivations.focus.loading = false;
	},

	[ADMIN_INIT_NEW_MOTIVATIONLIBRARY]: (state, action) => {
		state.motivations.focus.data = {};
		state.motivations.focus.loading = false;
	},
	/** ANSWERS **/
	[API_ADMIN_GET_ALL_ANSWEROPTIONLIBRARY]: (state, action) => {
		state.answers.list.loading = true;
	},

	[API_ADMIN_GET_ALL_ANSWEROPTIONLIBRARY_SUCCESS]: (state, action) => {
		const adaptedPayload = adaptAnswerOptionLibraryPayloadResponse(action, API_ADMIN_GET_ALL_ANSWEROPTIONLIBRARY);
		state.answers.list = {
			loading: false,
			data: adaptedPayload.data || [],
		};
	},

	[API_ADMIN_GET_ANSWEROPTIONLIBRARY_SUCCESS]: (state, action) => {
		const adaptedPayload = adaptAnswerOptionLibraryPayloadResponse(action, API_ADMIN_GET_ANSWEROPTIONLIBRARY);
		const currentClient = action.meta?.previousAction?.payload?.client || getAnswerOptionLibraryVersion(API_ADMIN_GET_ANSWEROPTIONLIBRARY).currentClient;
		state.answers.focus = {
			loading: false,
			data: adaptedPayload.data ? adaptAnswerOptionLibraryResponse(adaptedPayload.data, currentClient) : null,
		};
	},

	[API_ADMIN_POST_ANSWEROPTIONLIBRARY]: (state, action) => {
		state.answers.list.loading = true;
	},

	[API_ADMIN_POST_ANSWEROPTIONLIBRARY_FAIL]: (state, action) => {
		errorHandler("Catalogue de réponse", ErrorAction.CREATE, action.error);
		state.answers.list.loading = false;
	},

	[API_ADMIN_POST_ANSWEROPTIONLIBRARY_SUCCESS]: (state, action) => {
		toast.success("Nouvelle réponse ajoutée");

		const adaptedPayload = adaptAnswerOptionLibraryPayloadResponse(action, API_ADMIN_POST_ANSWEROPTIONLIBRARY);
		const currentClient = action.meta?.previousAction?.payload?.client || getAnswerOptionLibraryVersion(API_ADMIN_POST_ANSWEROPTIONLIBRARY).currentClient;
		const adaptedData = adaptedPayload.data ? adaptAnswerOptionLibraryResponse(adaptedPayload.data, currentClient) : null;

		state.answers.focus.loading = false;
		state.answers.focus.data = adaptedData;

		if (adaptedData) {
			state.answers.list.data.push(adaptedData);
		}
		state.answers.list.loading = false;
	},

	[API_ADMIN_PATCH_ANSWEROPTIONLIBRARY]: (state, action) => {
		state.answers.list.loading = true;
	},

	[API_ADMIN_PATCH_ANSWEROPTIONLIBRARY_FAIL]: (state, action) => {
		errorHandler("Catalogue de réponse", ErrorAction.UPDATE, action.error);
		state.answers.list.loading = false;
	},

	[API_ADMIN_PATCH_ANSWEROPTIONLIBRARY_SUCCESS]: (state, action) => {
		toast.success("La réponse a été modifiée");

		const adaptedPayload = adaptAnswerOptionLibraryPayloadResponse(action, API_ADMIN_PATCH_ANSWEROPTIONLIBRARY);
		const currentClient = action.meta?.previousAction?.payload?.client || getAnswerOptionLibraryVersion(API_ADMIN_PATCH_ANSWEROPTIONLIBRARY).currentClient;
		const adaptedData = adaptedPayload.data ? adaptAnswerOptionLibraryResponse(adaptedPayload.data, currentClient) : null;

		state.answers.focus.loading = false;
		state.answers.focus.data = adaptedData;

		if (adaptedData) {
			let index = state.answers.list.data.findIndex((i) => i.id === adaptedData.id);
			if (index >= 0) {
				state.answers.list.data[index] = adaptedData;
			}
		}
		state.answers.list.loading = false;
	},

	[API_ADMIN_DELETE_ANSWEROPTIONLIBRARY]: (state, action) => {
		state.answers.list.loading = true;
	},

	[API_ADMIN_DELETE_ANSWEROPTIONLIBRARY_FAIL]: (state, action) => {
		errorHandler("Catalogue de réponse", ErrorAction.DELETE, action.error);
		state.answers.list.loading = false;
	},

	[API_ADMIN_DELETE_ANSWEROPTIONLIBRARY_SUCCESS]: (state, action) => {
		let { data } = state.answers.list;
		state.answers.list.loading = false;
		data.splice(
			data.findIndex((i) => i.id === action.payload.data.id),
			1
		);
		state.answers.list.data = data;
		state.answers.focus.data = null;
	},

	[ADMIN_RESET_FOCUS_ANSWEROPTIONLIBRARY]: (state, action) => {
		state.answers.focus.data = null;
		state.answers.focus.loading = false;
	},

	[ADMIN_INIT_NEW_ANSWEROPTIONLIBRARY]: (state, action) => {
		state.answers.focus.data = {};
		state.answers.focus.loading = false;
	},

	/** SYSTEMATIC QUESTIONS **/

	[API_ADMIN_GET_ALL_SYSTEMATICQUESTIONLIBRARY]: (state, action) => {
		state.systematicQuestions.list.loading = true;
	},

	[API_ADMIN_GET_ALL_SYSTEMATICQUESTIONLIBRARY_SUCCESS]: (state, action) => {
		const adaptedPayload = adaptQuestionLibraryPayloadResponse(action, API_ADMIN_GET_ALL_SYSTEMATICQUESTIONLIBRARY);
		state.systematicQuestions.list = {
			loading: false,
			data: adaptedPayload.data || [],
		};
	},

	[API_ADMIN_GET_SYSTEMATICQUESTIONLIBRARY_SUCCESS]: (state, action) => {
		const adaptedPayload = adaptQuestionLibraryPayloadResponse(action, API_ADMIN_GET_SYSTEMATICQUESTIONLIBRARY);
		const currentClient = action.meta?.previousAction?.payload?.client || getQuestionLibraryVersion(API_ADMIN_GET_SYSTEMATICQUESTIONLIBRARY).currentClient;
		state.systematicQuestions.focus = {
			loading: false,
			data: adaptedPayload.data ? adaptQuestionLibraryResponse(adaptedPayload.data, currentClient) : null,
		};
	},

	[API_ADMIN_POST_SYSTEMATICQUESTIONLIBRARY]: (state, action) => {
		state.systematicQuestions.list.loading = true;
	},

	[API_ADMIN_POST_SYSTEMATICQUESTIONLIBRARY_FAIL]: (state, action) => {
		errorHandler("Catalogue de question systématique", ErrorAction.CREATE, action.error);
		state.systematicQuestions.list.loading = false;
	},

	[API_ADMIN_POST_SYSTEMATICQUESTIONLIBRARY_SUCCESS]: (state, action) => {
		toast.success("Nouvelle question ajoutée");

		const adaptedPayload = adaptQuestionLibraryPayloadResponse(action, API_ADMIN_POST_SYSTEMATICQUESTIONLIBRARY);
		const currentClient = action.meta?.previousAction?.payload?.client || getQuestionLibraryVersion(API_ADMIN_POST_SYSTEMATICQUESTIONLIBRARY).currentClient;
		const adaptedData = adaptedPayload.data ? adaptQuestionLibraryResponse(adaptedPayload.data, currentClient) : null;

		state.systematicQuestions.focus.loading = false;
		state.systematicQuestions.focus.data = adaptedData;

		if (adaptedData) {
			state.systematicQuestions.list.data.push(adaptedData);
		}
		state.systematicQuestions.list.loading = false;
	},

	[API_ADMIN_PATCH_SYSTEMATICQUESTIONLIBRARY]: (state, action) => {
		state.systematicQuestions.list.loading = true;
	},

	[API_ADMIN_PATCH_SYSTEMATICQUESTIONLIBRARY_FAIL]: (state, action) => {
		errorHandler("Catalogue de question systématique", ErrorAction.UPDATE, action.error);
		state.systematicQuestions.list.loading = false;
	},

	[API_ADMIN_PATCH_SYSTEMATICQUESTIONLIBRARY_SUCCESS]: (state, action) => {
		toast.success("La question a été modifiée");

		const adaptedPayload = adaptQuestionLibraryPayloadResponse(action, API_ADMIN_PATCH_SYSTEMATICQUESTIONLIBRARY);
		const currentClient = action.meta?.previousAction?.payload?.client || getQuestionLibraryVersion(API_ADMIN_PATCH_SYSTEMATICQUESTIONLIBRARY).currentClient;
		const adaptedData = adaptedPayload.data ? adaptQuestionLibraryResponse(adaptedPayload.data, currentClient) : null;

		state.systematicQuestions.focus.loading = false;
		state.systematicQuestions.focus.data = adaptedData;

		if (adaptedData) {
			let index = state.systematicQuestions.list.data.findIndex((i) => i.id === adaptedData.id);
			if (index >= 0) {
				state.systematicQuestions.list.data[index] = adaptedData;
			}
		}
		state.systematicQuestions.list.loading = false;
	},

	[API_ADMIN_DELETE_SYSTEMATICQUESTIONLIBRARY]: (state, action) => {
		state.systematicQuestions.list.loading = true;
	},

	[API_ADMIN_DELETE_SYSTEMATICQUESTIONLIBRARY_FAIL]: (state, action) => {
		errorHandler("Catalogue de question systématique", ErrorAction.DELETE, action.error);
		state.systematicQuestions.list.loading = false;
	},

	[API_ADMIN_DELETE_SYSTEMATICQUESTIONLIBRARY_SUCCESS]: (state, action) => {
		toast.success("La question a été supprimée");

		let { data } = state.systematicQuestions.list;
		state.systematicQuestions.list.loading = false;
		data.splice(
			data.findIndex((i) => i.id === action.payload.data.id),
			1
		);

		state.systematicQuestions.list.data = data;
		state.systematicQuestions.focus.data = null;
	},

	[ADMIN_RESET_FOCUS_SYSTEMATICQUESTIONLIBRARY]: (state, action) => {
		state.systematicQuestions.focus.data = null;
		state.systematicQuestions.focus.loading = false;
	},

	[ADMIN_INIT_NEW_SYSTEMATICQUESTIONLIBRARY]: (state, action) => {
		state.systematicQuestions.focus.data = {};
		state.systematicQuestions.focus.loading = false;
	},

	/** ANALYSES PACK **/
	[API_ADMIN_GET_ALL_ANALYSESPACK]: (state, action) => {
		state.analysesPacks.list.loading = true;
	},

	[API_ADMIN_GET_ALL_ANALYSESPACK_SUCCESS]: (state, action) => {
		state.analysesPacks.list = {
			loading: false,
			data: action.payload.data,
		};
	},

	[API_ADMIN_GET_ANALYSESPACK_SUCCESS]: (state, action) => {
		state.analysesPacks.focus = {
			loading: false,
			data: action.payload.data,
		};
	},

	[API_ADMIN_POST_ANALYSESPACK]: (state, action) => {
		state.analysesPacks.list.loading = true;
	},

	[API_ADMIN_POST_ANALYSESPACK_FAIL]: (state, action) => {
		errorHandler("Pack d'analyse", ErrorAction.CREATE, action.error);
		state.analysesPacks.list.loading = false;
	},

	[API_ADMIN_POST_ANALYSESPACK_SUCCESS]: (state, action) => {
		toast.success("Nouveau pack ajouté");

		state.analysesPacks.focus.loading = false;
		state.analysesPacks.focus.data = action.payload.data;

		state.analysesPacks.list.data.push(action.payload.data);
		state.analysesPacks.list.loading = false;
	},

	[API_ADMIN_PATCH_ANALYSESPACK]: (state, action) => {
		state.analysesPacks.list.loading = true;
	},

	[API_ADMIN_PATCH_ANALYSESPACK_FAIL]: (state, action) => {
		errorHandler("Pack d'analyse", ErrorAction.UPDATE, action.error);
		state.analysesPacks.list.loading = false;
	},

	[API_ADMIN_PATCH_ANALYSESPACK_SUCCESS]: (state, action) => {
		toast.success("Le pack a été modifié");

		state.analysesPacks.focus.loading = false;
		state.analysesPacks.focus.data = action.payload.data;

		let index = state.analysesPacks.list.data.findIndex((i) => i.id === action.payload.data.id);

		state.analysesPacks.list.data[index] = action.payload.data;
		state.analysesPacks.list.loading = false;
	},

	[API_ADMIN_DELETE_ANALYSESPACK]: (state, action) => {
		state.analysesPacks.list.loading = true;
	},

	[API_ADMIN_DELETE_ANALYSESPACK_FAIL]: (state, action) => {
		errorHandler("Pack d'analyse", ErrorAction.DELETE, action.error);
		state.analysesPacks.list.loading = false;
	},

	[API_ADMIN_DELETE_ANALYSESPACK_SUCCESS]: (state, action) => {
		toast.success("Le pack a été supprimé");

		let { data } = state.analysesPacks.list;
		state.analysesPacks.list.loading = false;
		data.splice(
			data.findIndex((i) => i.id === action.payload.data.id),
			1
		);
		state.analysesPacks.list.data = data;
		state.analysesPacks.focus.data = null;
	},

	[ADMIN_RESET_FOCUS_ANALYSESPACK]: (state, action) => {
		state.analysesPacks.focus.data = null;
		state.analysesPacks.focus.loading = false;
	},

	[ADMIN_INIT_NEW_ANALYSESPACK]: (state, action) => {
		state.analysesPacks.focus.data = {};
		state.analysesPacks.focus.loading = false;
	},

	/** Insurances */
	[API_ADMIN_GET_ALL_INSURANCE]: (state, action) => {
		state.insurances.list.loading = true;
	},

	[API_ADMIN_GET_ALL_INSURANCE_FAIL]: (state, action) => {
		errorHandler("Mutuelle", ErrorAction.READ, action.error);
		state.insurances.list = {
			loading: false,
			data: [],
		};
	},

	[API_ADMIN_GET_ALL_INSURANCE_SUCCESS]: (state, action) => {
		state.insurances.list = {
			loading: false,
			data: action.payload.data,
		};
	},

	[API_ADMIN_GET_INSURANCE]: (state, action) => {
		state.insurances.focus.loading = true;
	},

	[API_ADMIN_GET_INSURANCE_FAIL]: (state, action) => {
		state.insurances.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_GET_INSURANCE_SUCCESS]: (state, action) => {
		state.insurances.focus = {
			loading: false,
			data: action.payload.data,
		};
	},

	[ADMIN_INIT_NEW_INSURANCE]: (state, action) => {
		state.insurances.focus = {
			loading: false,
			data: {},
		};
	},

	[ADMIN_RESET_FOCUS_INSURANCE]: (state, action) => {
		state.insurances.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_POST_INSURANCE]: (state, action) => {
		state.insurances.list.loading = true;
	},

	[API_ADMIN_POST_INSURANCE_FAIL]: (state, action) => {
		errorHandler("Mutuelle", ErrorAction.CREATE, action.error);
		state.insurances.list.loading = false;
	},

	[API_ADMIN_POST_INSURANCE_SUCCESS]: (state, action) => {
		toast.success("Nouvelle mutuelle ajoutée");

		state.insurances.focus.loading = false;
		state.insurances.focus.data = action.payload.data;

		state.insurances.list.data.push(action.payload.data);
		state.insurances.list.loading = false;
	},

	[API_ADMIN_PATCH_INSURANCE]: (state, action) => {
		state.insurances.list.loading = true;
	},

	[API_ADMIN_PATCH_INSURANCE_FAIL]: (state, action) => {
		errorHandler("Mutuelle", ErrorAction.UPDATE, action.error);
		state.insurances.list.loading = false;
	},

	[API_ADMIN_PATCH_INSURANCE_SUCCESS]: (state, action) => {
		toast.success("La mutuelle a été modifiée");

		state.insurances.focus.loading = false;
		state.insurances.focus.data = action.payload.data;

		let index = state.insurances.list.data.findIndex((i) => i.id === action.payload.data.id);

		state.insurances.list.data[index] = action.payload.data;
		state.insurances.list.loading = false;
	},

	[API_ADMIN_DELETE_INSURANCE]: (state, action) => {
		state.insurances.list.loading = true;
	},

	[API_ADMIN_DELETE_INSURANCE_FAIL]: (state, action) => {
		errorHandler("Mutuelle", ErrorAction.DELETE, action.error);
		state.insurances.list.loading = false;
	},

	[API_ADMIN_DELETE_INSURANCE_SUCCESS]: (state, action) => {
		toast.success("La mutuelle a été supprimée");

		let { data } = state.insurances.list;
		state.insurances.list.loading = false;
		data.splice(
			data.findIndex((i) => i.id === action.payload.data.id),
			1
		);
		state.insurances.list.data = data;
		state.insurances.focus.data = null;
	},

	/** DOCUMENTTYPES */
	[API_ADMIN_GET_ALL_DOCUMENT_TYPE]: (state, action) => {
		state.documentTypes.list.loading = true;
	},

	[API_ADMIN_GET_ALL_DOCUMENT_TYPE_FAIL]: (state, action) => {
		errorHandler("Type de document", ErrorAction.READ, action.error);
		state.documentTypes.list = {
			loading: false,
			data: [],
		};
	},

	[API_ADMIN_GET_ALL_DOCUMENT_TYPE_SUCCESS]: (state, action) => {
		state.documentTypes.list = {
			loading: false,
			data: action.payload.data,
		};
	},

	[API_ADMIN_GET_DOCUMENT_TYPE]: (state, action) => {
		state.documentTypes.focus.loading = true;
	},

	[API_ADMIN_GET_DOCUMENT_TYPE_FAIL]: (state, action) => {
		state.documentTypes.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_GET_DOCUMENT_TYPE_SUCCESS]: (state, action) => {
		state.documentTypes.focus = {
			loading: false,
			data: action.payload.data,
		};
	},

	[ADMIN_INIT_NEW_DOCUMENT_TYPE]: (state, action) => {
		state.documentTypes.focus = {
			loading: false,
			data: {},
		};
	},

	[ADMIN_RESET_FOCUS_DOCUMENT_TYPE]: (state, action) => {
		state.documentTypes.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_POST_DOCUMENT_TYPE]: (state, action) => {
		state.documentTypes.list.loading = true;
	},

	[API_ADMIN_POST_DOCUMENT_TYPE_FAIL]: (state, action) => {
		if (action.error.response.status === 409 && action.error.response.data.message?.id)
			toast.warn(`Ajout impossible, il y a déjà un valeur par défaut pour les prescriptions: ${action.error.response.data.message.name}.`);
		else errorHandler("Type de document", ErrorAction.CREATE, action.error);
		state.documentTypes.list.loading = false;
	},

	[API_ADMIN_POST_DOCUMENT_TYPE_SUCCESS]: (state, action) => {
		toast.success("Nouveau type de document ajouté");

		state.documentTypes.focus.loading = false;
		state.documentTypes.focus.data = action.payload.data;

		state.documentTypes.list.data.push(action.payload.data);
		state.documentTypes.list.loading = false;
	},

	[API_ADMIN_PATCH_DOCUMENT_TYPE]: (state, action) => {
		state.documentTypes.list.loading = true;
	},

	[API_ADMIN_PATCH_DOCUMENT_TYPE_FAIL]: (state, action) => {
		if (action.error.response.status === 409 && action.error.response.data.message?.id)
			toast.warn(`Modification impossible, il y a déjà un valeur par défaut pour les prescriptions: ${action.error.response.data.message.name}.`);
		else errorHandler("Type de document", ErrorAction.UPDATE, action.error);
		state.documentTypes.list.loading = false;
	},

	[API_ADMIN_PATCH_DOCUMENT_TYPE_SUCCESS]: (state, action) => {
		toast.success("Le type de document a été modifié");

		state.documentTypes.focus.loading = false;
		state.documentTypes.focus.data = action.payload.data;

		let index = state.documentTypes.list.data.findIndex((i) => i.id === action.payload.data.id);

		state.documentTypes.list.data[index] = action.payload.data;
		state.documentTypes.list.loading = false;
	},

	[API_ADMIN_DELETE_DOCUMENT_TYPE]: (state, action) => {
		state.documentTypes.list.loading = true;
	},

	[API_ADMIN_DELETE_DOCUMENT_TYPE_FAIL]: (state, action) => {
		errorHandler("Type de document", ErrorAction.DELETE, action.error);
		state.documentTypes.list.loading = false;
	},

	[API_ADMIN_DELETE_DOCUMENT_TYPE_SUCCESS]: (state, action) => {
		toast.success("Le type de document a été supprimé");

		let { data } = state.documentTypes.list;
		state.documentTypes.list.loading = false;
		data.splice(
			data.findIndex((i) => i.id === action.payload.data.id),
			1
		);
		state.documentTypes.list.data = data;
		state.documentTypes.focus.data = null;
	},

	/** LabParamGroup */
	[API_ADMIN_GET_ALL_LAB_PARAM_GROUP]: (state, action) => {
		state.labParamGroups.list.loading = true;
	},

	[API_ADMIN_GET_ALL_LAB_PARAM_GROUP_FAIL]: (state, action) => {
		errorHandler("Groupe de paramétrage laboratoire", ErrorAction.READ, action.error);
		state.labParamGroups.list = {
			loading: false,
			data: [],
		};
	},

	[API_ADMIN_GET_ALL_LAB_PARAM_GROUP_SUCCESS]: (state, action) => {
		state.labParamGroups.list = {
			loading: false,
			data: action.payload.data,
		};
	},

	[API_ADMIN_GET_LAB_PARAM_GROUP]: (state, action) => {
		state.labParamGroups.focus.loading = true;
	},

	[API_ADMIN_GET_LAB_PARAM_GROUP_FAIL]: (state, action) => {
		state.labParamGroups.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_GET_LAB_PARAM_GROUP_SUCCESS]: (state, action) => {
		state.labParamGroups.focus = {
			loading: false,
			data: action.payload.data,
		};
	},

	[ADMIN_INIT_NEW_LAB_PARAM_GROUP]: (state, action) => {
		state.labParamGroups.focus = {
			loading: false,
			data: {},
		};
	},

	[ADMIN_RESET_FOCUS_LAB_PARAM_GROUP]: (state, action) => {
		state.labParamGroups.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_POST_LAB_PARAM_GROUP]: (state, action) => {
		state.labParamGroups.list.loading = true;
	},

	[API_ADMIN_POST_LAB_PARAM_GROUP_FAIL]: (state, action) => {
		errorHandler("Groupe de paramétrage laboratoire", ErrorAction.CREATE, action.error);
		state.labParamGroups.list.loading = false;
	},

	[API_ADMIN_POST_LAB_PARAM_GROUP_SUCCESS]: (state, action) => {
		toast.success("Nouveau groupe de paramétrage laboratoire ajoutée");

		state.labParamGroups.focus.loading = false;
		state.labParamGroups.focus.data = action.payload.data;

		state.labParamGroups.list.data.push(action.payload.data);
		state.labParamGroups.list.loading = false;
	},

	[API_ADMIN_PATCH_LAB_PARAM_GROUP]: (state, action) => {
		state.labParamGroups.list.loading = true;
	},

	[API_ADMIN_PATCH_LAB_PARAM_GROUP_FAIL]: (state, action) => {
		errorHandler("Groupe de paramétrage laboratoire", ErrorAction.PATCH, action.error);
		state.labParamGroups.list.loading = false;
	},

	[API_ADMIN_PATCH_LAB_PARAM_GROUP_SUCCESS]: (state, action) => {
		toast.success("Le groupe de paramétrage laboratoire a été modifié");

		state.labParamGroups.focus.loading = false;
		state.labParamGroups.focus.data = action.payload.data;

		let index = state.labParamGroups.list.data.findIndex((i) => i.id === action.payload.data.id);

		state.labParamGroups.list.data[index] = action.payload.data;
		state.labParamGroups.list.loading = false;
	},

	[API_ADMIN_DELETE_LAB_PARAM_GROUP]: (state, action) => {
		state.labParamGroups.list.loading = true;
	},

	[API_ADMIN_DELETE_LAB_PARAM_GROUP_FAIL]: (state, action) => {
		errorHandler("Groupe de paramétrage laboratoire", ErrorAction.DELETE, action.error);
		state.labParamGroups.list.loading = false;
	},

	[API_ADMIN_DELETE_LAB_PARAM_GROUP_SUCCESS]: (state, action) => {
		toast.success("Le groupe de paramétrage laboratoire a été supprimé");

		let { data } = state.labParamGroups.list;
		state.labParamGroups.list.loading = false;
		data.splice(
			data.findIndex((i) => i.id === action.payload.data.id),
			1
		);
		state.labParamGroups.list = data;
		state.labParamGroups.focus.data = null;
	},

	/** Laboratories */
	[API_ADMIN_GET_ALL_LABORATORY]: (state, action) => {
		state.laboratories.list.loading = true;
	},

	[API_ADMIN_GET_ALL_LABORATORY_FAIL]: (state, action) => {
		errorHandler("Laboratoire", ErrorAction.READ, action.error);
		state.laboratories.list = {
			loading: false,
			data: [],
		};
	},

	[API_ADMIN_GET_ALL_LABORATORY_SUCCESS]: (state, action) => {
		const adaptedPayload = adaptLaboratoryPayloadResponse(action, API_ADMIN_GET_ALL_LABORATORY);
		state.laboratories.list = {
			loading: false,
			data: adaptedPayload.data || [],
		};
	},

	[API_ADMIN_GET_LABORATORY]: (state, action) => {
		state.laboratories.focus.loading = true;
	},

	[API_ADMIN_GET_LABORATORY_FAIL]: (state, action) => {
		state.laboratories.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_GET_LABORATORY_SUCCESS]: (state, action) => {
		const adaptedPayload = adaptLaboratoryPayloadResponse(action, API_ADMIN_GET_LABORATORY);
		state.laboratories.focus = {
			loading: false,
			data: adaptedPayload.data,
		};
	},

	[ADMIN_INIT_NEW_LABORATORY]: (state, action) => {
		state.laboratories.focus = {
			loading: false,
			data: {},
		};
	},

	[ADMIN_RESET_FOCUS_LABORATORY]: (state, action) => {
		state.laboratories.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_POST_LABORATORY]: (state, action) => {
		state.laboratories.list.loading = true;
	},

	[API_ADMIN_POST_LABORATORY_FAIL]: (state, action) => {
		errorHandler("Laboratoire", ErrorAction.CREATE, action.error);
		state.laboratories.list.loading = false;
	},

	[API_ADMIN_POST_LABORATORY_SUCCESS]: (state, action) => {
		toast.success("Nouveau laboratoire ajoutée");
		const adaptedPayload = adaptLaboratoryPayloadResponse(action, API_ADMIN_POST_LABORATORY);

		state.laboratories.focus.loading = false;
		state.laboratories.focus.data = adaptedPayload.data;

		if (adaptedPayload.data) {
			state.laboratories.list.data.push(adaptedPayload.data);
		}
		state.laboratories.list.loading = false;
	},

	[API_ADMIN_PATCH_LABORATORY]: (state, action) => {
		state.laboratories.list.loading = true;
	},

	[API_ADMIN_PATCH_LABORATORY_FAIL]: (state, action) => {
		errorHandler("Laboratoire", ErrorAction.UPDATE, action.error);
		state.laboratories.list.loading = false;
	},

	[API_ADMIN_PATCH_LABORATORY_SUCCESS]: (state, action) => {
		toast.success("Le laboratoire a été modifié");
		const adaptedPayload = adaptLaboratoryPayloadResponse(action, API_ADMIN_PATCH_LABORATORY);

		state.laboratories.focus.loading = false;
		state.laboratories.focus.data = adaptedPayload.data;

		let index = state.laboratories.list.data.findIndex((i) => i.id === adaptedPayload.data?.id);

		if (index !== -1 && adaptedPayload.data) {
			state.laboratories.list.data[index] = adaptedPayload.data;
		}
		state.laboratories.list.loading = false;
	},

	[API_ADMIN_DELETE_LABORATORY]: (state, action) => {
		state.laboratories.list.loading = true;
	},

	[API_ADMIN_DELETE_LABORATORY_FAIL]: (state, action) => {
		errorHandler("Laboratoire", ErrorAction.DELETE, action.error);
		state.laboratories.list.loading = false;
	},

	[API_ADMIN_DELETE_LABORATORY_SUCCESS]: (state, action) => {
		toast.success("Le laboratoire a été supprimé");

		let { data } = state.laboratories.list;
		state.laboratories.list.loading = false;
		data.splice(
			data.findIndex((i) => i.id === action.payload.data.id),
			1
		);
		state.laboratories.list.data = data;
		state.laboratories.focus.data = null;
	},

	/** Special regimes */
	[API_ADMIN_GET_ALL_SPECIAL_REGIME]: (state, action) => {
		state.specialRegimes.list.loading = true;
	},

	[API_ADMIN_GET_ALL_SPECIAL_REGIME_FAIL]: (state, action) => {
		errorHandler("Régime spécial", ErrorAction.READ, action.error);
		state.specialRegimes.list = {
			loading: false,
			data: [],
		};
	},

	[API_ADMIN_GET_ALL_SPECIAL_REGIME_SUCCESS]: (state, action) => {
		state.specialRegimes.list = {
			loading: false,
			data: action.payload.data,
		};
	},

	[API_ADMIN_GET_SPECIAL_REGIME]: (state, action) => {
		state.specialRegimes.focus.loading = true;
	},

	[API_ADMIN_GET_SPECIAL_REGIME_FAIL]: (state, action) => {
		state.specialRegimes.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_GET_SPECIAL_REGIME_SUCCESS]: (state, action) => {
		state.specialRegimes.focus = {
			loading: false,
			data: action.payload.data,
		};
	},

	[ADMIN_INIT_NEW_SPECIAL_REGIME]: (state, action) => {
		state.specialRegimes.focus = {
			loading: false,
			data: {},
		};
	},

	[ADMIN_RESET_FOCUS_SPECIAL_REGIME]: (state, action) => {
		state.specialRegimes.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_POST_SPECIAL_REGIME]: (state, action) => {
		state.specialRegimes.list.loading = true;
	},

	[API_ADMIN_POST_SPECIAL_REGIME_FAIL]: (state, action) => {
		errorHandler("Régime spécial", ErrorAction.CREATE, action.error);
		state.specialRegimes.list.loading = false;
	},

	[API_ADMIN_POST_SPECIAL_REGIME_SUCCESS]: (state, action) => {
		toast.success("Nouvelle mutuelle ajouté");

		state.specialRegimes.focus.loading = false;
		state.specialRegimes.focus.data = action.payload.data;

		state.specialRegimes.list.data.push(action.payload.data);
		state.specialRegimes.list.loading = false;
	},

	[API_ADMIN_PATCH_SPECIAL_REGIME]: (state, action) => {
		state.specialRegimes.list.loading = true;
	},

	[API_ADMIN_PATCH_SPECIAL_REGIME_FAIL]: (state, action) => {
		errorHandler("Régime spécial", ErrorAction.UPDATE, action.error);
		state.specialRegimes.list.loading = false;
	},

	[API_ADMIN_PATCH_SPECIAL_REGIME_SUCCESS]: (state, action) => {
		toast.success("Le régime spécial a été modifié");

		state.specialRegimes.focus.loading = false;
		state.specialRegimes.focus.data = action.payload.data;

		let index = state.specialRegimes.list.data.findIndex((i) => i.id === action.payload.data.id);

		state.specialRegimes.list.data[index] = action.payload.data;
		state.specialRegimes.list.loading = false;
	},

	[API_ADMIN_DELETE_SPECIAL_REGIME]: (state, action) => {
		state.specialRegimes.list.loading = true;
	},

	[API_ADMIN_DELETE_SPECIAL_REGIME_FAIL]: (state, action) => {
		errorHandler("Régime spécial", ErrorAction.DELETE, action.error);
		state.specialRegimes.list.loading = false;
	},

	[API_ADMIN_DELETE_SPECIAL_REGIME_SUCCESS]: (state, action) => {
		toast.success("Le régime spécial a été supprimé");

		let { data } = state.specialRegimes.list;
		state.specialRegimes.list.loading = false;
		data.splice(
			data.findIndex((i) => i.id === action.payload.data.id),
			1
		);
		state.specialRegimes.list.data = data;
		state.specialRegimes.focus.data = null;
	},

	/** Specialties */
	[API_ADMIN_GET_ALL_SPECIALTY]: (state, action) => {
		state.specialties.list.loading = true;
	},

	[API_ADMIN_GET_ALL_SPECIALTY_FAIL]: (state, action) => {
		errorHandler("Spécialité", ErrorAction.READ, action.error);
		state.specialties.list = {
			loading: false,
			data: [],
		};
	},

	[API_ADMIN_GET_ALL_SPECIALTY_SUCCESS]: (state, action) => {
		state.specialties.list = {
			loading: false,
			data: action.payload.data,
		};
	},

	[API_ADMIN_GET_SPECIALTY]: (state, action) => {
		state.specialties.focus.loading = true;
	},

	[API_ADMIN_GET_SPECIALTY_FAIL]: (state, action) => {
		state.specialties.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_GET_SPECIALTY_SUCCESS]: (state, action) => {
		state.specialties.focus = {
			loading: false,
			data: action.payload.data,
		};
	},

	[ADMIN_INIT_NEW_SPECIALTY]: (state, action) => {
		state.specialties.focus = {
			loading: false,
			data: {},
		};
	},

	[ADMIN_RESET_FOCUS_SPECIALTY]: (state, action) => {
		state.specialties.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_POST_SPECIALTY]: (state, action) => {
		state.specialties.list.loading = true;
	},

	[API_ADMIN_POST_SPECIALTY_FAIL]: (state, action) => {
		errorHandler("Spécialité", ErrorAction.CREATE, action.error);
		state.specialties.list.loading = false;
	},

	[API_ADMIN_POST_SPECIALTY_SUCCESS]: (state, action) => {
		toast.success("Nouvelle spécialité ajoutée");

		state.specialties.focus.loading = false;
		state.specialties.focus.data = action.payload.data;

		state.specialties.list.data.push(action.payload.data);
		state.specialties.list.loading = false;
	},

	[API_ADMIN_PATCH_SPECIALTY]: (state, action) => {
		state.specialties.list.loading = true;
	},

	[API_ADMIN_PATCH_SPECIALTY_FAIL]: (state, action) => {
		errorHandler("Spécialité", ErrorAction.UPDATE, action.error);
		state.specialties.list.loading = false;
	},

	[API_ADMIN_PATCH_SPECIALTY_SUCCESS]: (state, action) => {
		toast.success("La spécialité a été modifiée");

		state.specialties.focus.loading = false;
		state.specialties.focus.data = action.payload.data;

		let index = state.specialties.list.data.findIndex((i) => i.id === action.payload.data.id);

		state.specialties.list.data[index] = action.payload.data;
		state.specialties.list.loading = false;
	},

	[API_ADMIN_DELETE_SPECIALTY]: (state, action) => {
		state.specialties.list.loading = true;
	},

	[API_ADMIN_DELETE_SPECIALTY_FAIL]: (state, action) => {
		errorHandler("Spécialité", ErrorAction.DELETE, action.error);
		state.specialties.list.loading = false;
	},

	[API_ADMIN_DELETE_SPECIALTY_SUCCESS]: (state, action) => {
		toast.success("La spécialité a été supprimée");

		let { data } = state.specialties.list;
		state.specialties.list.loading = false;
		data.splice(
			data.findIndex((i) => i.id === action.payload.data.id),
			1
		);
		state.specialties.list.data = data;
		state.specialties.focus.data = null;
	},

	/** Companies */
	[API_ADMIN_GET_ALL_COMPANY]: (state, action) => {
		state.companies.list.loading = true;
	},

	[API_ADMIN_GET_ALL_COMPANY_FAIL]: (state, action) => {
		errorHandler("Société", ErrorAction.READ, action.error);
		state.companies.list = {
			loading: false,
			data: [],
		};
	},

	[API_ADMIN_GET_ALL_COMPANY_SUCCESS]: (state, action) => {
		const adaptedPayload = adaptCompanyPayloadResponse(action, API_ADMIN_GET_ALL_COMPANY);
		state.companies.list = {
			loading: false,
			data: adaptedPayload.data || [],
		};
	},

	[API_ADMIN_GET_COMPANY]: (state, action) => {
		state.companies.focus.loading = true;
	},

	[API_ADMIN_GET_COMPANY_FAIL]: (state, action) => {
		state.companies.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_GET_COMPANY_SUCCESS]: (state, action) => {
		const adaptedPayload = adaptCompanyPayloadResponse(action, API_ADMIN_GET_COMPANY);
		state.companies.focus = {
			loading: false,
			data: adaptedPayload.data || null,
		};
	},

	[ADMIN_RESET_FOCUS_COMPANY]: (state, action) => {
		state.companies.focus = {
			loading: false,
			data: null,
		};
	},

	/** ConsentRefusalReasons */
	[API_ADMIN_GET_ALL_CONSENT_REFUSAL_REASON]: (state, action) => {
		state.consentRefusalReasons.list.loading = true;
	},

	[API_ADMIN_GET_ALL_CONSENT_REFUSAL_REASON_FAIL]: (state, action) => {
		errorHandler("Motif de refus de prise en charge", ErrorAction.READ, action.error);
		state.consentRefusalReasons.list = {
			loading: false,
			data: [],
		};
	},

	[API_ADMIN_GET_ALL_CONSENT_REFUSAL_REASON_SUCCESS]: (state, action) => {
		state.consentRefusalReasons.list = {
			loading: false,
			data: action.payload.data,
		};
	},

	[API_ADMIN_GET_CONSENT_REFUSAL_REASON]: (state, action) => {
		state.consentRefusalReasons.focus.loading = true;
	},

	[API_ADMIN_GET_CONSENT_REFUSAL_REASON_FAIL]: (state, action) => {
		state.consentRefusalReasons.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_GET_CONSENT_REFUSAL_REASON_SUCCESS]: (state, action) => {
		state.consentRefusalReasons.focus = {
			loading: false,
			data: action.payload.data,
		};
	},

	[ADMIN_INIT_NEW_CONSENT_REFUSAL_REASON]: (state, action) => {
		state.consentRefusalReasons.focus = {
			loading: false,
			data: {},
		};
	},

	[ADMIN_RESET_FOCUS_CONSENT_REFUSAL_REASON]: (state, action) => {
		state.consentRefusalReasons.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_POST_CONSENT_REFUSAL_REASON]: (state, action) => {
		state.consentRefusalReasons.list.loading = true;
	},

	[API_ADMIN_POST_CONSENT_REFUSAL_REASON_FAIL]: (state, action) => {
		errorHandler("Motif de refus de prise en charge", ErrorAction.CREATE, action.error);
		state.consentRefusalReasons.list.loading = false;
	},

	[API_ADMIN_POST_CONSENT_REFUSAL_REASON_SUCCESS]: (state, action) => {
		toast.success("Nouveau motif de refus de prise en charge ajouté");

		state.consentRefusalReasons.focus.loading = false;
		state.consentRefusalReasons.focus.data = action.payload.data;

		state.consentRefusalReasons.list.data.push(action.payload.data);
		state.consentRefusalReasons.list.loading = false;
	},

	[API_ADMIN_PATCH_CONSENT_REFUSAL_REASON]: (state, action) => {
		state.consentRefusalReasons.list.loading = true;
	},

	[API_ADMIN_PATCH_CONSENT_REFUSAL_REASON_FAIL]: (state, action) => {
		errorHandler("Motif de refus de prise en charge", ErrorAction.UPDATE, action.error);
		state.consentRefusalReasons.list.loading = false;
	},

	[API_ADMIN_PATCH_CONSENT_REFUSAL_REASON_SUCCESS]: (state, action) => {
		toast.success("Le motif de refus de prise en charge a été modifié");

		state.consentRefusalReasons.focus.loading = false;
		state.consentRefusalReasons.focus.data = action.payload.data;

		let index = state.consentRefusalReasons.list.data.findIndex((i) => i.id === action.payload.data.id);

		state.consentRefusalReasons.list.data[index] = action.payload.data;
		state.consentRefusalReasons.list.loading = false;
	},

	[API_ADMIN_DELETE_CONSENT_REFUSAL_REASON]: (state, action) => {
		state.consentRefusalReasons.list.loading = true;
	},

	[API_ADMIN_DELETE_CONSENT_REFUSAL_REASON_FAIL]: (state, action) => {
		errorHandler("Motif de refus de prise en charge", ErrorAction.DELETE, action.error);
		state.consentRefusalReasons.list.loading = false;
	},

	[API_ADMIN_DELETE_CONSENT_REFUSAL_REASON_SUCCESS]: (state, action) => {
		toast.success("Le motif de refus de prise en charge a été supprimé");

		let { data } = state.consentRefusalReasons.list;
		state.consentRefusalReasons.list.loading = false;
		data.splice(
			data.findIndex((i) => i.id === action.payload.data.id),
			1
		);
		state.consentRefusalReasons.list.data = data;
		state.consentRefusalReasons.focus.data = null;
	},

	/** EmergencyReasons */
	[API_ADMIN_GET_ALL_EMERGENCY_REASON]: (state, action) => {
		state.emergencyReasons.list.loading = true;
	},

	[API_ADMIN_GET_ALL_EMERGENCY_REASON_FAIL]: (state, action) => {
		errorHandler("Motif d'urgence", ErrorAction.READ, action.error);
		state.emergencyReasons.list = {
			loading: false,
			data: [],
		};
	},

	[API_ADMIN_GET_ALL_EMERGENCY_REASON_SUCCESS]: (state, action) => {
		state.emergencyReasons.list = {
			loading: false,
			data: action.payload.data,
		};
	},

	[API_ADMIN_GET_EMERGENCY_REASON]: (state, action) => {
		state.emergencyReasons.focus.loading = true;
	},

	[API_ADMIN_GET_EMERGENCY_REASON_FAIL]: (state, action) => {
		state.emergencyReasons.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_GET_EMERGENCY_REASON_SUCCESS]: (state, action) => {
		state.emergencyReasons.focus = {
			loading: false,
			data: action.payload.data,
		};
	},

	[ADMIN_INIT_NEW_EMERGENCY_REASON]: (state, action) => {
		state.emergencyReasons.focus = {
			loading: false,
			data: {},
		};
	},

	[ADMIN_RESET_FOCUS_EMERGENCY_REASON]: (state, action) => {
		state.emergencyReasons.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_POST_EMERGENCY_REASON]: (state, action) => {
		state.emergencyReasons.list.loading = true;
	},

	[API_ADMIN_POST_EMERGENCY_REASON_FAIL]: (state, action) => {
		errorHandler("Motif d'urgence", ErrorAction.CREATE, action.error);
		state.emergencyReasons.list.loading = false;
	},

	[API_ADMIN_POST_EMERGENCY_REASON_SUCCESS]: (state, action) => {
		toast.success("Nouveau motif d'urgence ajouté");

		state.emergencyReasons.focus.loading = false;
		state.emergencyReasons.focus.data = action.payload.data;

		state.emergencyReasons.list.data.push(action.payload.data);
		state.emergencyReasons.list.loading = false;
	},

	[API_ADMIN_PATCH_EMERGENCY_REASON]: (state, action) => {
		state.emergencyReasons.list.loading = true;
	},

	[API_ADMIN_PATCH_EMERGENCY_REASON_FAIL]: (state, action) => {
		errorHandler("Motif d'urgence", ErrorAction.UPDATE, action.error);
		state.emergencyReasons.list.loading = false;
	},

	[API_ADMIN_PATCH_EMERGENCY_REASON_SUCCESS]: (state, action) => {
		toast.success("Le motif d'urgence a été modifié");

		state.emergencyReasons.focus.loading = false;
		state.emergencyReasons.focus.data = action.payload.data;

		let index = state.emergencyReasons.list.data.findIndex((i) => i.id === action.payload.data.id);

		state.emergencyReasons.list.data[index] = action.payload.data;
		state.emergencyReasons.list.loading = false;
	},

	[API_ADMIN_DELETE_EMERGENCY_REASON]: (state, action) => {
		state.emergencyReasons.list.loading = true;
	},

	[API_ADMIN_DELETE_EMERGENCY_REASON_FAIL]: (state, action) => {
		errorHandler("Motif d'urgence", ErrorAction.DELETE, action.error);
		state.emergencyReasons.list.loading = false;
	},

	[API_ADMIN_DELETE_EMERGENCY_REASON_SUCCESS]: (state, action) => {
		toast.success("Le motif d'urgence a été supprimé");

		let { data } = state.emergencyReasons.list;
		state.emergencyReasons.list.loading = false;
		data.splice(
			data.findIndex((i) => i.id === action.payload.data.id),
			1
		);
		state.emergencyReasons.list.data = data;
		state.emergencyReasons.focus.data = null;
	},

	/**TubeReasons */
	[API_ADMIN_GET_ALL_TUBE_REASON]: (state, action) => {
		state.tubeReasons.list.loading = true;
	},

	[API_ADMIN_GET_ALL_TUBE_REASON_FAIL]: (state, action) => {
		errorHandler("Motif tube", ErrorAction.READ, action.error);
		state.tubeReasons.list = {
			loading: false,
			data: [],
		};
	},

	[API_ADMIN_GET_ALL_TUBE_REASON_SUCCESS]: (state, action) => {
		state.tubeReasons.list = {
			loading: false,
			data: action.payload.data,
		};
	},

	[API_ADMIN_GET_TUBE_REASON]: (state, action) => {
		state.tubeReasons.focus.loading = true;
	},

	[API_ADMIN_GET_TUBE_REASON_FAIL]: (state, action) => {
		state.tubeReasons.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_GET_TUBE_REASON_SUCCESS]: (state, action) => {
		state.tubeReasons.focus = {
			loading: false,
			data: action.payload.data,
		};
	},

	[ADMIN_INIT_NEW_TUBE_REASON]: (state, action) => {
		state.tubeReasons.focus = {
			loading: false,
			data: {},
		};
	},

	[ADMIN_RESET_FOCUS_TUBE_REASON]: (state, action) => {
		state.tubeReasons.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_POST_TUBE_REASON]: (state, action) => {
		state.tubeReasons.list.loading = true;
	},

	[API_ADMIN_POST_TUBE_REASON_FAIL]: (state, action) => {
		errorHandler("Motif tube", ErrorAction.CREATE, action.error);
		state.tubeReasons.list.loading = false;
	},

	[API_ADMIN_POST_TUBE_REASON_SUCCESS]: (state, action) => {
		toast.success("Nouveau motif de non prélèvement ajoutée");

		state.tubeReasons.focus.loading = false;
		state.tubeReasons.focus.data = action.payload.data;

		state.tubeReasons.list.data.push(action.payload.data);
		state.tubeReasons.list.loading = false;
	},

	[API_ADMIN_PATCH_TUBE_REASON]: (state, action) => {
		state.tubeReasons.list.loading = true;
	},

	[API_ADMIN_PATCH_TUBE_REASON_FAIL]: (state, action) => {
		errorHandler("Motif tube", ErrorAction.UPDATE, action.error);
		state.tubeReasons.list.loading = false;
	},

	[API_ADMIN_PATCH_TUBE_REASON_SUCCESS]: (state, action) => {
		toast.success("Le motif de non prélèvement a été modifié");

		state.tubeReasons.focus.loading = false;
		state.tubeReasons.focus.data = action.payload.data;

		let index = state.tubeReasons.list.data.findIndex((i) => i.id === action.payload.data.id);

		state.tubeReasons.list.data[index] = action.payload.data;
		state.tubeReasons.list.loading = false;
	},

	[API_ADMIN_DELETE_TUBE_REASON]: (state, action) => {
		state.tubeReasons.list.loading = true;
	},

	[API_ADMIN_DELETE_TUBE_REASON_FAIL]: (state, action) => {
		errorHandler("Motif tube", ErrorAction.DELETE, action.error);
		state.tubeReasons.list.loading = false;
	},

	[API_ADMIN_DELETE_TUBE_REASON_SUCCESS]: (state, action) => {
		toast.success("Le motif de non prélèvement a été supprimé");

		let { data } = state.tubeReasons.list;
		state.tubeReasons.list.loading = false;
		data.splice(
			data.findIndex((i) => i.id === action.payload.data.id),
			1
		);
		state.tubeReasons.list.data = data;
		state.tubeReasons.focus.data = null;
	},

	[API_ADMIN_GET_TUBE_REASON_GROUPS_FAIL]: (state, action) => {
		errorHandler("Groupe de motif", ErrorAction.READ, action.error);
		state.tubeReasons.groups = [];
	},

	[API_ADMIN_GET_TUBE_REASON_GROUPS_SUCCESS]: (state, action) => {
		state.tubeReasons.groups = action.payload.data;
	},

	/**CancelReasons */
	[API_ADMIN_GET_ALL_CANCEL_REASON]: (state, action) => {
		state.cancelReasons.list.loading = true;
	},

	[API_ADMIN_GET_ALL_CANCEL_REASON_FAIL]: (state, action) => {
		errorHandler("Raison d'annulation", ErrorAction.READ, action.error);
		state.cancelReasons.list = {
			loading: false,
			data: [],
		};
	},

	[API_ADMIN_GET_ALL_CANCEL_REASON_SUCCESS]: (state, action) => {
		state.cancelReasons.list = {
			loading: false,
			data: action.payload.data,
		};
	},

	[API_ADMIN_GET_CANCEL_REASON]: (state, action) => {
		state.cancelReasons.focus.loading = true;
	},

	[API_ADMIN_GET_CANCEL_REASON_FAIL]: (state, action) => {
		state.cancelReasons.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_GET_CANCEL_REASON_SUCCESS]: (state, action) => {
		state.cancelReasons.focus = {
			loading: false,
			data: action.payload.data,
		};
	},

	[ADMIN_INIT_NEW_CANCEL_REASON]: (state, action) => {
		state.cancelReasons.focus = {
			loading: false,
			data: {},
		};
	},

	[ADMIN_RESET_FOCUS_CANCEL_REASON]: (state, action) => {
		state.cancelReasons.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_POST_CANCEL_REASON]: (state, action) => {
		state.cancelReasons.list.loading = true;
	},

	[API_ADMIN_POST_CANCEL_REASON_FAIL]: (state, action) => {
		errorHandler("Raison d'annulation", ErrorAction.CREATE, action.error);
		state.cancelReasons.list.loading = false;
	},

	[API_ADMIN_POST_CANCEL_REASON_SUCCESS]: (state, action) => {
		toast.success("Nouvelle raison d'annulation ajoutée");

		state.cancelReasons.focus.loading = false;
		state.cancelReasons.focus.data = action.payload.data;

		state.cancelReasons.list.data.push(action.payload.data);
		state.cancelReasons.list.loading = false;
	},

	[API_ADMIN_PATCH_CANCEL_REASON]: (state, action) => {
		state.cancelReasons.list.loading = true;
	},

	[API_ADMIN_PATCH_CANCEL_REASON_FAIL]: (state, action) => {
		errorHandler("Raison d'annulation", ErrorAction.UPDATE, action.error);
		state.cancelReasons.list.loading = false;
	},

	[API_ADMIN_PATCH_CANCEL_REASON_SUCCESS]: (state, action) => {
		toast.success("La raison d'annulation a été modifiée");

		state.cancelReasons.focus.loading = false;
		state.cancelReasons.focus.data = action.payload.data;

		let index = state.cancelReasons.list.data.findIndex((i) => i.id === action.payload.data.id);

		state.cancelReasons.list.data[index] = action.payload.data;
		state.cancelReasons.list.loading = false;
	},

	[API_ADMIN_DELETE_CANCEL_REASON]: (state, action) => {
		state.cancelReasons.list.loading = true;
	},

	[API_ADMIN_DELETE_CANCEL_REASON_FAIL]: (state, action) => {
		errorHandler("Raison d'annulation", ErrorAction.DELETE, action.error);
		state.cancelReasons.list.loading = false;
	},

	[API_ADMIN_DELETE_CANCEL_REASON_SUCCESS]: (state, action) => {
		toast.success("La raison d'annulation a été supprimée");

		let { data } = state.cancelReasons.list;
		state.cancelReasons.list.loading = false;
		data.splice(
			data.findIndex((i) => i.id === action.payload.data.id),
			1
		);
		state.cancelReasons.list.data = data;
		state.cancelReasons.focus.data = null;
	},

	[API_ADMIN_GET_CANCEL_REASON_GROUPS_FAIL]: (state, action) => {
		errorHandler("Groupe de raisons d'annulations", ErrorAction.READ, action.error);
		state.cancelReasons.groups = [];
	},

	[API_ADMIN_GET_CANCEL_REASON_GROUPS_SUCCESS]: (state, action) => {
		state.cancelReasons.groups = action.payload.data;
	},

	/** CONTACT COMMENT */
	[API_ADMIN_GET_ALL_CONTACT_COMMENT]: (state, action) => {
		state.contactComments.list.loading = true;
	},

	[API_ADMIN_GET_ALL_CONTACT_COMMENT_FAIL]: (state, action) => {
		errorHandler("Commentaire contact", ErrorAction.READ, action.error);
		state.contactComments.list = {
			loading: false,
			data: [],
		};
	},

	[API_ADMIN_GET_ALL_CONTACT_COMMENT_SUCCESS]: (state, action) => {
		state.contactComments.list = {
			loading: false,
			data: action.payload.data,
		};
	},

	[API_ADMIN_GET_CONTACT_COMMENT]: (state, action) => {
		state.contactComments.focus.loading = true;
	},

	[API_ADMIN_GET_CONTACT_COMMENT_FAIL]: (state, action) => {
		state.contactComments.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_GET_CONTACT_COMMENT_SUCCESS]: (state, action) => {
		state.contactComments.focus = {
			loading: false,
			data: action.payload.data,
		};
	},

	[ADMIN_INIT_NEW_CONTACT_COMMENT]: (state, action) => {
		state.contactComments.focus = {
			loading: false,
			data: {},
		};
	},

	[ADMIN_RESET_FOCUS_CONTACT_COMMENT]: (state, action) => {
		state.contactComments.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_POST_CONTACT_COMMENT]: (state, action) => {
		state.contactComments.list.loading = true;
	},

	[API_ADMIN_POST_CONTACT_COMMENT_FAIL]: (state, action) => {
		errorHandler("Commentaire contact", ErrorAction.CREATE, action.error);
		state.contactComments.list.loading = false;
	},

	[API_ADMIN_POST_CONTACT_COMMENT_SUCCESS]: (state, action) => {
		toast.success("Nouveau commentaire contact ajoutée");

		state.contactComments.focus.loading = false;
		state.contactComments.focus.data = action.payload.data;

		state.contactComments.list.data.push(action.payload.data);
		state.contactComments.list.loading = false;
	},

	[API_ADMIN_PATCH_CONTACT_COMMENT]: (state, action) => {
		state.contactComments.list.loading = true;
	},

	[API_ADMIN_PATCH_CONTACT_COMMENT_FAIL]: (state, action) => {
		errorHandler("Commentaire contact", ErrorAction.UPDATE, action.error);
		state.contactComments.list.loading = false;
	},

	[API_ADMIN_PATCH_CONTACT_COMMENT_SUCCESS]: (state, action) => {
		toast.success("Le commentaire contact a été modifié");

		state.contactComments.focus.loading = false;
		state.contactComments.focus.data = action.payload.data;

		let index = state.contactComments.list.data.findIndex((i) => i.id === action.payload.data.id);

		state.contactComments.list.data[index] = action.payload.data;
		state.contactComments.list.loading = false;
	},

	[API_ADMIN_DELETE_CONTACT_COMMENT]: (state, action) => {
		state.contactComments.list.loading = true;
	},

	[API_ADMIN_DELETE_CONTACT_COMMENT_FAIL]: (state, action) => {
		errorHandler("Commentaire contact", ErrorAction.DELETE, action.error);
		state.contactComments.list.loading = false;
	},

	[API_ADMIN_DELETE_CONTACT_COMMENT_SUCCESS]: (state, action) => {
		toast.success("Le commentaire contact a été supprimé");

		let { data } = state.contactComments.list;
		state.contactComments.list.loading = false;
		data.splice(
			data.findIndex((i) => i.id === action.payload.data.id),
			1
		);
		state.contactComments.list.data = data;
		state.contactComments.focus.data = null;
	},

	/** CENTERS */
	[API_ADMIN_GET_ALL_CENTER]: (state, action) => {
		state.centers.list.loading = true;
	},

	[API_ADMIN_GET_ALL_CENTER_FAIL]: (state, action) => {
		errorHandler("Centre", ErrorAction.READ, action.error);
		state.centers.list = {
			loading: false,
			data: [],
		};
	},

	[API_ADMIN_GET_ALL_CENTER_SUCCESS]: (state, action) => {
		state.centers.list = {
			loading: false,
			data: action.payload.data,
		};
	},

	[API_ADMIN_GET_CENTER]: (state) => {
		state.centers.focus.loading = true;
	},

	[API_ADMIN_GET_CENTER_FAIL]: (state, action) => {
		state.centers.focus = {
			loading: false,
			data: null,
		};
		errorHandler("Centre", ErrorAction.READ, action.error);
	},

	[API_ADMIN_GET_CENTER_SUCCESS]: (state, action) => {
		state.centers.focus = {
			loading: false,
			data: action.payload.data,
		};
	},

	[API_ADMIN_GET_CENTER_SUCCESS]: (state, action) => {
		state.centers.focus = {
			loading: false,
			data: action.payload.data,
		};
	},

	[ADMIN_INIT_NEW_CENTER]: (state, action) => {
		state.centers.focus = {
			loading: false,
			data: {},
		};
	},

	[ADMIN_RESET_FOCUS_CENTER]: (state, action) => {
		state.centers.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_POST_CENTER]: (state) => {
		state.centers.list.loading = true;
	},

	[API_ADMIN_POST_CENTER_FAIL]: (state, action) => {
		state.centers.list.loading = false;
		errorHandler("Centre", ErrorAction.CREATE, action.error);
	},

	[API_ADMIN_POST_CENTER_SUCCESS]: (state, action) => {
		toast.success("Nouveau centre ajouté");

		state.centers.focus.loading = false;
		state.centers.focus.data = action.payload.data;

		state.centers.list.data.push(action.payload.data);
		state.centers.list.loading = false;
	},

	[API_ADMIN_PATCH_CENTER]: (state) => {
		state.centers.list.loading = true;
	},

	[API_ADMIN_PATCH_CENTER_FAIL]: (state, action) => {
		state.centers.list.loading = false;
		errorHandler("Centre", ErrorAction.UPDATE, action.error);
	},

	[API_ADMIN_PATCH_CENTER_SUCCESS]: (state, action) => {
		toast.success("Le centre a été modifié");

		state.centers.focus.loading = false;
		state.centers.focus.data = action.payload.data;

		let index = state.centers.list.data.findIndex((i) => i.id === action.payload.data.id);

		state.centers.list.data[index] = action.payload.data;
		state.centers.list.loading = false;
	},

	[API_ADMIN_DELETE_CENTER]: (state) => {
		state.centers.list.loading = true;
	},

	[API_ADMIN_DELETE_CENTER_FAIL]: (state, action) => {
		state.centers.list.loading = false;
		errorHandler("Centre", ErrorAction.DELETE, action.error);
	},

	[API_ADMIN_DELETE_CENTER_SUCCESS]: (state, action) => {
		toast.success("Le centre a été supprimé");

		let { data } = state.centers.list;
		state.centers.list.loading = false;
		data.splice(
			data.findIndex((i) => i.id === action.payload.data.id),
			1
		);
		state.centers.list.data = data;
		state.centers.focus.data = null;
	},

	[API_ADMIN_IMPORT_CENTER]: (state) => {
		state.centers.list.loading = true;
	},

	[API_ADMIN_IMPORT_CENTER_FAIL]: (state, action) => {
		state.centers.list.loading = false;
		errorHandler("Centre", ErrorAction.CREATE, action.error);
	},

	[API_ADMIN_IMPORT_CENTER_SUCCESS]: (state, action) => {
		toast.success("Type de prélèvements importées");

		state.centers.focus.loading = false;
		state.centers.focus.data = null;

		state.centers.list.data = action.payload.data.centers;
		state.centers.list.loading = false;
	},

	[API_GET_CENTERS_MY_RDV_SUCCESS]: (state, action) => {
		state.centers.myRdv = action.payload.data;
	},

	/** CAMPAIGNS */
	[API_ADMIN_GET_ALL_CAMPAIGNS]: (state, action) => {
		state.campaigns.list.loading = true;
	},

	[API_ADMIN_GET_ALL_CAMPAIGNS_FAIL]: (state, action) => {
		errorHandler("Campagne", ErrorAction.READ, action.error);
		state.campaigns.list = {
			loading: false,
			data: [],
		};
	},

	[API_ADMIN_GET_ALL_CAMPAIGNS_SUCCESS]: (state, action) => {
		const adaptedPayload = adaptCampaignPayloadResponse(action, API_ADMIN_GET_ALL_CAMPAIGNS);
		state.campaigns.list = {
			loading: false,
			data: adaptedPayload.data || [],
		};
	},

	[API_ADMIN_GET_CAMPAIGN]: (state) => {
		state.campaigns.focus.loading = true;
	},

	[API_ADMIN_GET_CAMPAIGN_FAIL]: (state, action) => {
		state.campaigns.focus = {
			loading: false,
			data: null,
		};
		errorHandler("Campagne", ErrorAction.READ, action.error);
	},

	[API_ADMIN_GET_CAMPAIGN_SUCCESS]: (state, action) => {
		const adaptedPayload = adaptCampaignPayloadResponse(action, API_ADMIN_GET_CAMPAIGN);
		state.campaigns.focus = {
			loading: false,
			data: adaptedPayload.data || null,
		};
	},

	[API_GET_CAMPAIGNS_RECORDS_PAGE_SUCCESS]: (state, action) => {
		const adaptedPayload = adaptCampaignPayloadResponse(action, API_GET_CAMPAIGNS_RECORDS_PAGE);
		if (state.campaigns.focus.data) {
			state.campaigns.focus.data.records = adaptedPayload.data || [];
		}
	},

	[ADMIN_INIT_NEW_CAMPAIGN]: (state, action) => {
		state.campaigns.focus = {
			loading: false,
			data: {},
		};
	},

	[ADMIN_RESET_FOCUS_CAMPAIGN]: (state, action) => {
		state.campaigns.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_POST_CAMPAIGN]: (state) => {
		state.campaigns.list.loading = true;
	},

	[API_ADMIN_POST_CAMPAIGN_FAIL]: (state, action) => {
		state.campaigns.list.loading = false;
		errorHandler("Campagne", ErrorAction.CREATE, action.error);
	},

	[API_ADMIN_POST_CAMPAIGN_SUCCESS]: (state, action) => {
		toast.success("La campage a été modifiée");
		const adaptedPayload = adaptCampaignPayloadResponse(action, API_ADMIN_POST_CAMPAIGN);

		state.campaigns.focus.loading = false;
		state.campaigns.focus.data = adaptedPayload.data || null;

		if (adaptedPayload.data) {
			let index = state.campaigns.list.data.findIndex((i) => i.id === adaptedPayload.data.id);
			if (index >= 0) {
				state.campaigns.list.data[index] = adaptedPayload.data;
			}
		}
		state.campaigns.list.loading = false;
	},

	[API_ADMIN_PATCH_CAMPAIGN]: (state) => {
		state.campaigns.list.loading = true;
	},

	[API_ADMIN_PATCH_CAMPAIGN_FAIL]: (state, action) => {
		state.campaigns.list.loading = false;
		errorHandler("Campagne", ErrorAction.UPDATE, action.error);
	},

	[API_ADMIN_PATCH_CAMPAIGN_SUCCESS]: (state, action) => {
		toast.success("Nouvelle campagne ajoutée");
		const adaptedPayload = adaptCampaignPayloadResponse(action, API_ADMIN_PATCH_CAMPAIGN);

		state.campaigns.focus.loading = false;
		state.campaigns.focus.data = adaptedPayload.data || null;

		if (adaptedPayload.data) {
			state.campaigns.list.data.push(adaptedPayload.data);
		}
		state.campaigns.list.loading = false;
	},

	[API_ADMIN_DELETE_CAMPAIGN]: (state) => {
		state.campaigns.list.loading = true;
	},

	[API_ADMIN_DELETE_CAMPAIGN_FAIL]: (state, action) => {
		state.campaigns.list.loading = false;
		errorHandler("Campagne", ErrorAction.DELETE, action.error);
	},

	[API_ADMIN_DELETE_CAMPAIGN_SUCCESS]: (state, action) => {
		toast.success("La campagne a été désactivée");
		let { data } = state.campaigns.list;
		state.campaigns.list.loading = false;
		data.splice(
			data.findIndex((i) => i.id === Number(action.payload.data.id)),
			1
		);
		state.campaigns.list.data = data;
		state.campaigns.focus.data = null;
	},
	[API_ADMIN_GET_ANALYSESPACKS_CAMPAIGNS]: (state) => {
		state.campaigns.packs = { loading: true };
	},
	[API_ADMIN_GET_ANALYSESPACKS_CAMPAIGNS_SUCCESS]: (state, action) => {
		state.campaigns.packs.loading = false;
		state.campaigns.packs.data = action.payload.data;
	},
	[API_ADMIN_GET_ANALYSESPACKS_CAMPAIGNS_FAIL]: (state) => {
		state.campaigns.packs.loading = false;
		state.campaigns.packs.data = null;
	},

	/** BOXES */
	[API_ADMIN_GET_ALL_BOXES]: (state, action) => {
		state.boxes.list.loading = true;
	},

	[API_ADMIN_GET_ALL_BOXES_FAIL]: (state, action) => {
		errorHandler("Box", ErrorAction.READ, action.error);
		state.boxes.list = {
			loading: false,
			data: [],
		};
	},

	[API_ADMIN_GET_ALL_BOXES_SUCCESS]: (state, action) => {
		const adaptedPayload = adaptBoxPayloadResponse(action, API_ADMIN_GET_ALL_BOXES);
		state.boxes.list = {
			loading: false,
			data: adaptedPayload.data || [],
		};
	},

	[API_ADMIN_GET_BOX]: (state) => {
		state.boxes.focus.loading = true;
	},

	[API_ADMIN_GET_BOX_FAIL]: (state, action) => {
		state.boxes.focus = {
			loading: false,
			data: null,
		};
		errorHandler("Centre", ErrorAction.READ, action.error);
	},

	[API_ADMIN_GET_BOX_SUCCESS]: (state, action) => {
		const adaptedPayload = adaptBoxPayloadResponse(action, API_ADMIN_GET_BOX);
		state.boxes.focus = {
			loading: false,
			data: adaptedPayload.data,
		};
	},

	[ADMIN_INIT_NEW_BOX]: (state, action) => {
		state.boxes.focus = {
			loading: false,
			data: {},
		};
	},

	[ADMIN_RESET_FOCUS_BOX]: (state, action) => {
		state.boxes.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_POST_BOX]: (state) => {
		state.boxes.list.loading = true;
	},

	[API_ADMIN_POST_BOX_FAIL]: (state, action) => {
		state.boxes.list.loading = false;
		errorHandler("Box", ErrorAction.CREATE, action.error);
	},

	[API_ADMIN_POST_BOX_SUCCESS]: (state, action) => {
		toast.success("Nouveau box ajouté");
		const adaptedPayload = adaptBoxPayloadResponse(action, API_ADMIN_POST_BOX);

		state.boxes.focus.loading = false;
		state.boxes.focus.data = adaptedPayload.data;

		if (adaptedPayload.data) {
			state.boxes.list.data.push(adaptedPayload.data);
		}
		state.boxes.list.loading = false;
	},

	[API_ADMIN_PATCH_BOX]: (state) => {
		state.boxes.list.loading = true;
	},

	[API_ADMIN_PATCH_BOX_FAIL]: (state, action) => {
		state.boxes.list.loading = false;
		errorHandler("Box", ErrorAction.UPDATE, action.error);
	},

	[API_ADMIN_PATCH_BOX_SUCCESS]: (state, action) => {
		toast.success("Le box a été modifié");
		const adaptedPayload = adaptBoxPayloadResponse(action, API_ADMIN_PATCH_BOX);

		state.boxes.focus.loading = false;
		state.boxes.focus.data = adaptedPayload.data;

		let index = state.boxes.list.data.findIndex((i) => i.id === adaptedPayload.data?.id);

		if (index !== -1 && adaptedPayload.data) {
			state.boxes.list.data[index] = adaptedPayload.data;
		}
		state.boxes.list.loading = false;
	},

	[API_ADMIN_DELETE_BOX]: (state) => {
		state.boxes.list.loading = true;
	},

	[API_ADMIN_DELETE_BOX_FAIL]: (state, action) => {
		state.boxes.list.loading = false;
		errorHandler("Box", ErrorAction.DELETE, action.error);
	},

	[API_ADMIN_DELETE_BOX_SUCCESS]: (state, action) => {
		toast.success("Le box a été supprimé");
		let { data } = state.boxes.list;
		state.boxes.list.loading = false;
		data.splice(
			data.findIndex((i) => i.id === Number(action.payload.data.id)),
			1
		);
		state.boxes.list.data = data;
		state.boxes.focus.data = null;
	},

	/** SCANNERS */
	[API_ADMIN_GET_ALL_SCANNERS]: (state, action) => {
		state.scanners.list.loading = true;
	},

	[API_ADMIN_GET_ALL_SCANNERS_FAIL]: (state, action) => {
		errorHandler("Scanner", ErrorAction.READ, action.error);
		state.scanners.list = {
			loading: false,
			data: [],
		};
	},

	[API_ADMIN_GET_ALL_SCANNERS_SUCCESS]: (state, action) => {
		state.scanners.list = {
			loading: false,
			data: action.payload.data,
		};
	},

	[API_ADMIN_GET_SCANNER]: (state) => {
		state.scanners.focus.loading = true;
	},

	[API_ADMIN_GET_SCANNER_FAIL]: (state, action) => {
		state.scanners.focus = {
			loading: false,
			data: null,
		};
		errorHandler("Scanner", ErrorAction.READ, action.error);
	},

	[API_ADMIN_GET_SCANNER_SUCCESS]: (state, action) => {
		state.scanners.focus = {
			loading: false,
			data: action.payload.data,
		};
	},

	[ADMIN_INIT_NEW_SCANNER]: (state, action) => {
		state.scanners.focus = {
			loading: false,
			data: {},
		};
	},

	[ADMIN_RESET_FOCUS_SCANNER]: (state, action) => {
		state.scanners.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_POST_SCANNER]: (state) => {
		state.scanners.list.loading = true;
	},

	[API_ADMIN_POST_SCANNER_FAIL]: (state, action) => {
		state.scanners.list.loading = false;
		errorHandler("Scanner", ErrorAction.CREATE, action.error);
	},

	[API_ADMIN_POST_SCANNER_SUCCESS]: (state, action) => {
		toast.success("Nouveau scanner ajouté");

		state.scanners.focus.loading = false;
		state.scanners.focus.data = action.payload.data;

		state.scanners.list.data.push(action.payload.data);
		state.scanners.list.loading = false;
	},

	[API_ADMIN_PATCH_SCANNER]: (state) => {
		state.scanners.list.loading = true;
	},

	[API_ADMIN_PATCH_SCANNER_FAIL]: (state, action) => {
		state.scanners.list.loading = false;
		errorHandler("Scanner", ErrorAction.UPDATE, action.error);
	},

	[API_ADMIN_PATCH_SCANNER_SUCCESS]: (state, action) => {
		toast.success("Le scanner a été modifié");

		state.scanners.focus.loading = false;
		state.scanners.focus.data = action.payload.data;

		let index = state.scanners.list.data.findIndex((i) => i.id === action.payload.data.id);

		state.scanners.list.data[index] = action.payload.data;
		state.scanners.list.loading = false;
	},

	[API_ADMIN_DELETE_SCANNER]: (state) => {
		state.scanners.list.loading = true;
	},

	[API_ADMIN_DELETE_SCANNER_FAIL]: (state, action) => {
		state.scanners.list.loading = false;
		errorHandler("Scanner", ErrorAction.DELETE, action.error);
	},

	[API_ADMIN_DELETE_SCANNER_SUCCESS]: (state, action) => {
		toast.success("Le scanner a été supprimé");
		let { data } = state.scanners.list;
		state.scanners.list.loading = false;
		data.splice(
			data.findIndex((i) => i.id === Number(action.payload.data.id)),
			1
		);
		state.scanners.list.data = data;
		state.scanners.focus.data = null;
	},

	/** SAMPLE TYPES */
	[API_ADMIN_GET_ALL_SAMPLE_TYPE]: (state, action) => {
		state.sampleTypes.list.loading = true;
	},

	[API_ADMIN_GET_ALL_SAMPLE_TYPE_FAIL]: (state, action) => {
		errorHandler("Type de prélèvement", ErrorAction.READ, action.error);
		state.sampleTypes.list = {
			loading: false,
			data: [],
		};
	},

	[API_ADMIN_GET_ALL_SAMPLE_TYPE_SUCCESS]: (state, action) => {
		state.sampleTypes.list = {
			loading: false,
			data: action.payload.data,
		};
	},

	[API_ADMIN_GET_SAMPLE_TYPE]: (state) => {
		state.sampleTypes.focus.loading = true;
	},

	[API_ADMIN_GET_SAMPLE_TYPE_FAIL]: (state, action) => {
		state.sampleTypes.focus = {
			loading: false,
			data: null,
		};
		errorHandler("Type de prélèvement", ErrorAction.READ, action.error);
	},

	[API_ADMIN_GET_SAMPLE_TYPE_SUCCESS]: (state, action) => {
		state.sampleTypes.focus = {
			loading: false,
			data: action.payload.data,
		};
	},

	[ADMIN_INIT_NEW_SAMPLE_TYPE]: (state, action) => {
		state.sampleTypes.focus = {
			loading: false,
			data: {},
		};
	},

	[ADMIN_RESET_FOCUS_SAMPLE_TYPE]: (state, action) => {
		state.sampleTypes.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_POST_SAMPLE_TYPE]: (state) => {
		state.sampleTypes.list.loading = true;
	},

	[API_ADMIN_POST_SAMPLE_TYPE_FAIL]: (state, action) => {
		state.sampleTypes.list.loading = false;
		errorHandler("Type de prélèvement", ErrorAction.CREATE, action.error);
	},

	[API_ADMIN_POST_SAMPLE_TYPE_SUCCESS]: (state, action) => {
		toast.success("Nouveau type de prélèvement ajouté");

		state.sampleTypes.focus.loading = false;
		state.sampleTypes.focus.data = action.payload.data;

		state.sampleTypes.list.data.push(action.payload.data);
		state.sampleTypes.list.loading = false;
	},

	[API_ADMIN_PATCH_SAMPLE_TYPE]: (state) => {
		state.sampleTypes.list.loading = true;
	},

	[API_ADMIN_PATCH_SAMPLE_TYPE_FAIL]: (state, action) => {
		state.sampleTypes.list.loading = false;
		errorHandler("Type de prélèvement", ErrorAction.UPDATE, action.error);
	},

	[API_ADMIN_PATCH_SAMPLE_TYPE_SUCCESS]: (state, action) => {
		toast.success("Le type de prélèvement a été modifié");

		state.sampleTypes.focus.loading = false;
		state.sampleTypes.focus.data = action.payload.data;

		let index = state.sampleTypes.list.data.findIndex((i) => i.id === action.payload.data.id);

		state.sampleTypes.list.data[index] = action.payload.data;
		state.sampleTypes.list.loading = false;
	},

	[API_ADMIN_DELETE_SAMPLE_TYPE]: (state) => {
		state.sampleTypes.list.loading = true;
	},

	[API_ADMIN_DELETE_SAMPLE_TYPE_FAIL]: (state, action) => {
		state.sampleTypes.list.loading = false;
		errorHandler("Type de prélèvement", ErrorAction.DELETE, action.error);
	},

	[API_ADMIN_DELETE_SAMPLE_TYPE_SUCCESS]: (state, action) => {
		toast.success("Le type de prélèvement a été supprimé");

		let { data } = state.sampleTypes.list;
		state.sampleTypes.list.loading = false;
		data.splice(
			data.findIndex((i) => i.id === action.payload.data.id),
			1
		);
		state.sampleTypes.list.data = data;
		state.sampleTypes.focus.data = null;
	},

	/** SERVIPAY TERMINALS */
	[API_ADMIN_GET_ALL_SERVIPAY_TERMINAL]: (state, action) => {
		state.servipayTerminals.list.loading = true;
	},

	[API_ADMIN_GET_ALL_SERVIPAY_TERMINAL_FAIL]: (state, action) => {
		errorHandler("Terminal Servipay", ErrorAction.READ, action.error);
		state.servipayTerminals.list = {
			loading: false,
			data: [],
		};
	},

	[API_ADMIN_GET_ALL_SERVIPAY_TERMINAL_SUCCESS]: (state, action) => {
		state.servipayTerminals.list = {
			loading: false,
			data: action.payload.data,
		};
	},

	[API_ADMIN_GET_SERVIPAY_TERMINAL]: (state) => {
		state.servipayTerminals.focus.loading = true;
	},

	[API_ADMIN_GET_SERVIPAY_TERMINAL_FAIL]: (state, action) => {
		state.servipayTerminals.focus = {
			loading: false,
			data: null,
		};
		errorHandler("Terminal Servipay", ErrorAction.READ, action.error);
	},

	[API_ADMIN_GET_SERVIPAY_TERMINAL_SUCCESS]: (state, action) => {
		state.servipayTerminals.focus = {
			loading: false,
			data: action.payload.data,
		};
	},

	[ADMIN_INIT_NEW_SERVIPAY_TERMINAL]: (state, action) => {
		state.servipayTerminals.focus = {
			loading: false,
			data: {},
		};
	},

	[ADMIN_RESET_FOCUS_SERVIPAY_TERMINAL]: (state, action) => {
		state.servipayTerminals.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_POST_SERVIPAY_TERMINAL]: (state) => {
		state.servipayTerminals.list.loading = true;
	},

	[API_ADMIN_POST_SERVIPAY_TERMINAL_FAIL]: (state, action) => {
		state.servipayTerminals.list.loading = false;
		errorHandler("Terminal Servipay", ErrorAction.CREATE, action.error);
	},

	[API_ADMIN_POST_SERVIPAY_TERMINAL_SUCCESS]: (state, action) => {
		toast.success("Nouveau terminal Servipay ajouté");

		state.servipayTerminals.focus.loading = false;
		state.servipayTerminals.focus.data = action.payload.data;

		state.servipayTerminals.list.data.push(action.payload.data);
		state.servipayTerminals.list.loading = false;
	},

	[API_ADMIN_PATCH_SERVIPAY_TERMINAL]: (state) => {
		state.servipayTerminals.list.loading = true;
	},

	[API_ADMIN_PATCH_SERVIPAY_TERMINAL_FAIL]: (state, action) => {
		state.servipayTerminals.list.loading = false;
		errorHandler("Terminal Servipay", ErrorAction.UPDATE, action.error);
	},

	[API_ADMIN_PATCH_SERVIPAY_TERMINAL_SUCCESS]: (state, action) => {
		toast.success("Le terminal Servipay a été modifié");

		state.servipayTerminals.focus.loading = false;
		state.servipayTerminals.focus.data = action.payload.data;

		let index = state.servipayTerminals.list.data.findIndex((i) => i.id === action.payload.data.id);

		state.servipayTerminals.list.data[index] = action.payload.data;
		state.servipayTerminals.list.loading = false;
	},

	[API_ADMIN_DELETE_SERVIPAY_TERMINAL]: (state) => {
		state.servipayTerminals.list.loading = true;
	},

	[API_ADMIN_DELETE_SERVIPAY_TERMINAL_FAIL]: (state, action) => {
		state.servipayTerminals.list.loading = false;
		errorHandler("Terminal Servipay", ErrorAction.DELETE, action.error);
	},

	[API_ADMIN_DELETE_SERVIPAY_TERMINAL_SUCCESS]: (state, action) => {
		toast.success("Le terminal Servipay a été supprimé");

		let { data } = state.servipayTerminals.list;
		state.servipayTerminals.list.loading = false;
		data.splice(
			data.findIndex((i) => i.id === action.payload.data.id),
			1
		);
		state.servipayTerminals.list.data = data;
		state.servipayTerminals.focus.data = null;
	},

	/** ValidationPausedReasons */
	[API_ADMIN_GET_ALL_VALIDATION_PAUSED_REASON]: (state, action) => {
		state.validationPausedReasons.list.loading = true;
	},

	[API_ADMIN_GET_ALL_VALIDATION_PAUSED_REASON_FAIL]: (state, action) => {
		errorHandler("Motif de pause validation", ErrorAction.READ, action.error);
		state.validationPausedReasons.list = {
			loading: false,
			data: [],
		};
	},

	[API_ADMIN_GET_ALL_VALIDATION_PAUSED_REASON_SUCCESS]: (state, action) => {
		state.validationPausedReasons.list = {
			loading: false,
			data: action.payload.data,
		};
	},

	[API_ADMIN_GET_VALIDATION_PAUSED_REASON]: (state, action) => {
		state.validationPausedReasons.focus.loading = true;
	},

	[API_ADMIN_GET_VALIDATION_PAUSED_REASON_FAIL]: (state, action) => {
		state.validationPausedReasons.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_GET_VALIDATION_PAUSED_REASON_SUCCESS]: (state, action) => {
		state.validationPausedReasons.focus = {
			loading: false,
			data: action.payload.data,
		};
	},

	[ADMIN_INIT_NEW_VALIDATION_PAUSED_REASON]: (state, action) => {
		state.validationPausedReasons.focus = {
			loading: false,
			data: {},
		};
	},

	[ADMIN_RESET_FOCUS_VALIDATION_PAUSED_REASON]: (state, action) => {
		state.validationPausedReasons.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_POST_VALIDATION_PAUSED_REASON]: (state, action) => {
		state.validationPausedReasons.list.loading = true;
	},

	[API_ADMIN_POST_VALIDATION_PAUSED_REASON_FAIL]: (state, action) => {
		errorHandler("Motif de pause validation", ErrorAction.CREATE, action.error);
		state.validationPausedReasons.list.loading = false;
	},

	[API_ADMIN_POST_VALIDATION_PAUSED_REASON_SUCCESS]: (state, action) => {
		toast.success("Nouveau motif de pause validation");

		state.validationPausedReasons.focus.loading = false;
		state.validationPausedReasons.focus.data = action.payload.data;

		state.validationPausedReasons.list.data.push(action.payload.data);
		state.validationPausedReasons.list.loading = false;
	},

	[API_ADMIN_PATCH_VALIDATION_PAUSED_REASON]: (state, action) => {
		state.validationPausedReasons.list.loading = true;
	},

	[API_ADMIN_PATCH_VALIDATION_PAUSED_REASON_FAIL]: (state, action) => {
		errorHandler("Motif de pause validation", ErrorAction.UPDATE, action.error);
		state.validationPausedReasons.list.loading = false;
	},

	[API_ADMIN_PATCH_VALIDATION_PAUSED_REASON_SUCCESS]: (state, action) => {
		toast.success("Le motif de pause validation a été modifié");

		state.validationPausedReasons.focus.loading = false;
		state.validationPausedReasons.focus.data = action.payload.data;

		let index = state.validationPausedReasons.list.data.findIndex((i) => i.id === action.payload.data.id);

		state.validationPausedReasons.list.data[index] = action.payload.data;
		state.validationPausedReasons.list.loading = false;
	},

	[API_ADMIN_DELETE_VALIDATION_PAUSED_REASON]: (state, action) => {
		state.validationPausedReasons.list.loading = true;
	},

	[API_ADMIN_DELETE_VALIDATION_PAUSED_REASON_FAIL]: (state, action) => {
		errorHandler("Motif de pause validation", ErrorAction.DELETE, action.error);
		state.validationPausedReasons.list.loading = false;
	},

	[API_ADMIN_DELETE_VALIDATION_PAUSED_REASON_SUCCESS]: (state, action) => {
		toast.success("Le motif de pause validation a été supprimé");

		let { data } = state.validationPausedReasons.list;
		state.validationPausedReasons.list.loading = false;
		data.splice(
			data.findIndex((i) => i.id === action.payload.data.id),
			1
		);
		state.validationPausedReasons.list.data = data;
		state.validationPausedReasons.focus.data = null;
	},

	[API_GET_ANALYSIS_IMPORT]: (state, action) => {
		state.catalog.loading = true;
	},

	[API_GET_ANALYSIS_IMPORT_SUCCESS]: (state, action) => {
		state.catalog.loading = false;
		toast.success(<div>Catalogue importé</div>);
	},
	[API_GET_ANALYSIS_IMPORT_FAIL]: (state, action) => {
		state.catalog.loading = false;
		toast.error("L'import du catalogue via un appel à l'API du CA a échoué");
	},

	[API_GET_CONNECTED_USERS_WS]: (state, action) => {
		state.connected.loading = true;
	},
	[API_GET_CONNECTED_USERS_WS_SUCCESS]: (state, action) => {
		state.connected.loading = false;
		state.connected.list = action.payload.data;
	},

	/** PARTNERS COMPANIES */
	[API_ADMIN_GET_ALL_PARTNERS]: (state, action) => {
		state.partners.list.loading = true;
	},

	[API_ADMIN_GET_ALL_PARTNERS_FAIL]: (state, action) => {
		errorHandler("Société de prélèvement partenaire", ErrorAction.READ, action.error);
		state.partners.list = {
			loading: false,
			data: [],
		};
	},

	[API_ADMIN_GET_ALL_PARTNERS_SUCCESS]: (state, action) => {
		state.partners.list = {
			loading: false,
			data: action.payload.data,
		};
	},

	[API_ADMIN_GET_PARTNER]: (state) => {
		state.partners.focus.loading = true;
	},

	[API_ADMIN_GET_PARTNER_FAIL]: (state, action) => {
		state.partners.focus = {
			loading: false,
			data: null,
		};
		errorHandler("Société de prélèvement partenaire", ErrorAction.READ, action.error);
	},

	[API_ADMIN_GET_PARTNER_SUCCESS]: (state, action) => {
		state.partners.focus = {
			loading: false,
			data: action.payload.data,
		};
	},

	[API_ADMIN_GET_PARTNER_SUCCESS]: (state, action) => {
		state.partners.focus = {
			loading: false,
			data: action.payload.data,
		};
	},

	[ADMIN_INIT_NEW_PARTNER]: (state, action) => {
		state.partners.focus = {
			loading: false,
			data: {},
		};
	},

	[ADMIN_RESET_FOCUS_PARTNER]: (state, action) => {
		state.partners.focus = {
			loading: false,
			data: null,
		};
	},

	[API_ADMIN_POST_PARTNER]: (state) => {
		state.partners.list.loading = true;
	},

	[API_ADMIN_POST_PARTNER_FAIL]: (state, action) => {
		state.partners.list.loading = false;
		errorHandler("Société de prélèvement partenaire", ErrorAction.CREATE, action.error);
	},

	[API_ADMIN_POST_PARTNER_SUCCESS]: (state, action) => {
		toast.success("Nouvelle société de prélèvement ajoutée");

		state.partners.focus.loading = false;
		state.partners.focus.data = action.payload.data;

		state.partners.list.data.push(action.payload.data);
		state.partners.list.loading = false;
	},

	[API_ADMIN_PATCH_PARTNER]: (state) => {
		state.partners.list.loading = true;
	},

	[API_ADMIN_PATCH_PARTNER_FAIL]: (state, action) => {
		state.partners.list.loading = false;
		errorHandler("Société de prélèvement partenaire", ErrorAction.UPDATE, action.error);
	},

	[API_ADMIN_PATCH_PARTNER_SUCCESS]: (state, action) => {
		toast.success("La société de prélèvement partenaire a été modifiée");

		state.partners.focus.loading = false;
		state.partners.focus.data = action.payload.data;

		let index = state.partners.list.data.findIndex((i) => i.id === action.payload.data.id);

		state.partners.list.data[index] = action.payload.data;
		state.partners.list.loading = false;
	},

	[API_ADMIN_DELETE_PARTNER]: (state) => {
		state.partners.list.loading = true;
	},

	[API_ADMIN_DELETE_PARTNER_FAIL]: (state, action) => {
		state.partners.list.loading = false;
		errorHandler("Société de prélèvement partenaire", ErrorAction.DELETE, action.error);
	},

	[API_ADMIN_DELETE_PARTNER_SUCCESS]: (state, action) => {
		toast.success("La société de prélèvement partenaire a été supprimée");

		let { data } = state.partners.list;
		state.partners.list.loading = false;
		data.splice(
			data.findIndex((i) => i.id === action.payload.data.id),
			1
		);
		state.partners.list.data = data;
		state.partners.focus.data = null;
	},
});

export default admin;
